{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            Copyright (c) 2025                                      }
{            Email : info@tmssoftware.com                            }
{            Web : http://www.tmssoftware.com                        }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.DataGrid;

{$IFNDEF PAS2JS}
  {$DEFINE DESIGNER}
{$ELSE}
  {$MODE DELPHI}
{$ENDIF}






//{$DEFINE NOPP}

interface

uses
  WEBLib.DataGrid.Common,
  Classes, web, JS, WEBLib.Controls, WEBLib.Graphics, SysUtils,
{$IFDEF PAS2JS}
  libaggrid,
  WEBLib.DataGrid.liblocale,
  WEBLib.RegularExpressions, Generics.Collections, Generics.Defaults,
{$ELSE}
  System.UITypes, Vcl.Controls, Vcl.StdCtrls, Vcl.Graphics,
  System.RegularExpressions, System.Generics.Collections, System.Generics.Defaults,
{$IFDEF DESIGNER}
  Vcl.Grids, Winapi.Windows,

{$ENDIF}
{$ENDIF}
  WEBLib.StdCtrls, WebLib.Menus,
  WEBLib.DataGrid.Options,
  WEBLib.DataGrid.DataAdapter.Base,
  WEBLib.DataGrid.Injections,
  jsdelphisystem,
  System.Math,
  libdatagrid, Types, lib.propertyserializer, WEBLib.DataGrid.libjs;



type

{$REGION 'Events'}
  TDataGridRequestEvent = procedure(Sender: TObject; ARequest: TJSXMLHttpRequestRecord) of object;
  TDGRowSelectedCallBack = procedure(Event: TJSRowSelectedEvent) of object;
  TDGCellEditingEvent = procedure(Params: TJSCellEditingEvent) of object;
  TDGRowEditingEvent = procedure(Params: TJSRowEditingEvent) of object;
  TDGTabToNextCellEvent = function(Params: TJSTabToNextCellParams): TJSValue of object;
  TDGPaginationChangedEvent = procedure(Event: TJSPaginationChangedEvent) of object;
  TDGSelectionChangedEvent = procedure(Event: TJSSelectionChangedEvent) of object;
  TDGSortChangedEvent = procedure(Event: TJSSortChangedEvent) of object;
  TDGFilterChangedEvent = procedure(Event: TJSFilterChangedEvent) of object;
  TDGGetRowStyleCallback = function(Params: TJSGetRowStyleParams): TJSObject of object;
  TDGGetRowClassCallback = function(Params: TJSGetRowClassParams): TJSValue of object;
  TDGGetRowHeightCallback = function(Params: TJSRowHeightParams): TJSObject of object;

  TDGCellClickedEvent = procedure(Event: TJSCellClickedEvent) of object;
  TDGCellDoubleClickedEvent = procedure(Event: TJSCellDoubleClickedEvent) of object;
  TDGCellFocusedEvent = procedure(Event: TJSCellFocusedEvent) of object;
  TDGCellMouseOverEvent = procedure(Event: TJSCellMouseDownEvent) of object;
  TDGCellMouseDown = procedure(Event: TJSCellMouseDownEvent) of object;
  TDGGetLocaleTextCallBack = function(Params: TJSGetLocaleTextParams): string of object;
{$ENDREGION}
{$REGION 'Enums'}
  TDGRowSelectionType = (rsSingle, rsMultiple);
  TDGRowEditType = (retCell, retFullRow);
  TDGLocale = (localeNone, localeBG, localeBR, localeCN, localeCZ, localeDE,
    localeDK, localeEG, localeEN, localeES, localeFI, localeFR, localeGR,
    localeHK, localeHR, localeHU, localeIL, localeIR, localeIT, localeJP,
    localeKR, localeNL, localeNO, localePK, localePL, localePT, localeRO,
    localeSE, localeSK, localeTR, localeTW, localeUA, localeVN);
{$ENDREGION}

{$REGION 'Designer Compatibility'}
{$IFDEF DESIGNER}
  TElementEvent = (eeClick, eeMouseDown, eeMouseUp, eeMouseMove, eeDblClick, eeKeyPress, eeKeyDown, eeKeyUp);
  TEventPropagation = set of TElementEvent;


  TArrayHelper<T> = class abstract
  public
    class procedure Sort(var AValues: array of T;
      const AComparer: IComparer<T>); overload;
  end;
{$ENDIF}

  TDGDesignerGridBase = class({$IFDEF DESIGNER}TCustomGrid{$ELSE}{NOPP}TWebCustomControl{$ENDIF})
{$IFDEF DESIGNER}
{$REGION 'Compatibility'}
    private
      FEventStopPropagation: TEventPropagation;
      FElementID: TElementID;
      FWidthStyle: TSizeStyle;
      FWidthPercent: TPercentSize;
      FHeightPercent: TPercentSize;
      FHeightStyle: TSizeStyle;
      FCenter: TCenter;
      FDesignerGridData: array of array of string;
      FDesignerGridMergeLeft: array of array of Boolean;
      FDesignerGridMergeBottom: array of array of Boolean;

      procedure SetCenter(const Value: TCenter);
      procedure DoCenterChanged(Sender: TObject); virtual;

    protected
      FColWidthUpdating: boolean;

      function CreateElement: TJSElement; virtual; abstract;
      property EventStopPropagation: TEventPropagation read FEventStopPropagation write FEventStopPropagation;

    procedure SizeChanged(OldColCount, OldRowCount: Longint); override;

    public
      constructor Create(AOwner: TComponent); override;
      destructor Destroy; override;

      procedure CreateInitialize; virtual; abstract;

      property Center: TCenter read FCenter write SetCenter;
      property ElementID: TElementID read FElementID write FElementID;
      property HeightStyle: TSizeStyle read FHeightStyle write FHeightStyle default ssAbsolute;
      property HeightPercent: TPercentSize read FHeightPercent write FHeightPercent;
      property WidthStyle: TSizeStyle read FWidthStyle write FWidthStyle default ssAbsolute;
      property WidthPercent: TPercentSize read FWidthPercent write FWidthPercent;
{$ENDREGION}
{$REGION 'Designer Specific'}
  public
    procedure DrawCell(ACol, ARow: Longint; ARect: TRect;
      AState: TGridDrawState); override;
    procedure DrawCellBackground(const ARect: TRect; AColor: TColor;
      AState: TGridDrawState; ACol, ARow: Integer); override;
    procedure SetBounds(ALeft, ATop, AWidth, AHeight: Integer); override;
    procedure Paint; override;
    function ColumnDefsCount: Integer; virtual;

{$ENDREGION}
{$ENDIF}
  end;
{$ENDREGION}

{$REGION 'DataGrid'}
  { TDataGridBase }

  TDataGridBase = class(TDGDesignerGridBase)
  private

{$IFNDEF DESIGNER}
    FIsLoaded: Boolean;
    FIsSchemaAttempted: Boolean;
{$ENDIF}

    FMultilevelHeaders: TDGMultilevelHeaderCollection;
    FBanding: TDGBanding;
    FTheming: TDGTheming;
    FDefaultColDef: TDGDefaultColDef;
    FPagination: Boolean;
    FPaginationAutoPageSize: Boolean;
    FPaginationPageSize: Integer;
    FRowSelection: TDGRowSelectionType;
    FRowMultiSelectWithClick: Boolean;

    FEditType: TDGRowEditType;
    FLocale: TDGLocale;
    FServerDataAdapter: TDGServerDataAdapter;
    
    FOnRowSelected: TDGRowSelectedCallBack;
    FOnRowUnselected: TDGRowSelectedCallBack;
    FOnCellEditingStarted: TDGCellEditingEvent;
    FOnCellEditingEnded: TDGCellEditingEvent;
    FOnRowEditingStarted: TDGRowEditingEvent;
    FOnRowEditingEnded: TDGRowEditingEvent;
    FOnTabToNextCell: TDGTabToNextCellEvent;
    FOnSelectionChanged: TDGSelectionChangedEvent;
    FOnCellValueChanged: TDGCellEditingEvent;
    FOnPaginationChanged: TDGPaginationChangedEvent;
    FOnSortChanged: TDGSortChangedEvent;
    FOnFilterChanged: TDGFilterChangedEvent;

    FOnCellMouseDown: TDGCellMouseDown;
    FOnCellFocusedEvent: TDGCellFocusedEvent;
    FOnCellMouseOverEvent: TDGCellMouseOverEvent;
    FOnCellClickedEvent: TDGCellClickedEvent;
    FOnCellDoubleClickedEvent: TDGCellDoubleClickedEvent;

    FOnGetLocaleText: TDGGetLocaleTextCallBack;

    FPaginationPageSizeSelector: String;
    FCacheBlockSize: Integer;
    FMaxBlocksInCache: Integer;
    FBidiMode: TBiDiMode;
    FOnGetRowStyle: TDGGetRowStyleCallback;
    FOnGetRowClass: TDGGetRowClassCallback;
    FOnGetRowHeight: TDGGetRowHeightCallback;
    FEnableClickSelection: Boolean;
    FSuppressMoveWhenColumnDragging: Boolean;
    FRowHeight: Integer;

    function IsFontStored: Boolean;
    procedure InitFont(Value: TFont);
    procedure SetPaginationPageSizeSelector(const Value: String);
{$IFNDEF DESIGNER}
    function GetElementID: String;
{$ENDIF}
    procedure SetCacheBlockSize(const Value: Integer);
    procedure SetEditType(const Value: TDGRowEditType);
    procedure SetBidiMode(const Value: TBiDiMode); reintroduce;
    procedure SetMaxBlocksInCache(const Value: Integer);
    procedure SetPagination(const Value: Boolean);
    procedure SetPaginationAutoPageSize(const Value: Boolean);
    procedure SetPaginationPageSize(const Value: Integer);
    procedure SetRowMultiSelectWithClick(const Value: Boolean);
    procedure SetRowSelection(const Value: TDGRowSelectionType);

    function GetRowDataByFieldName(RowID: TJSValue; FieldName: String): TJSValue;
    procedure SetRowDataByFieldName(RowID: TJSValue; FieldName: String; const Value: TJSValue);
    function GetRowDataById(RowID: TJSValue; ColumnIndex: Integer): TJSValue;
    procedure SetRowDataById(RowID: TJSValue; ColumnIndex: Integer; const Value: TJSValue);

    function GetCellByFieldName(DisplayedRowIndex: TJSValue; FieldName: String): TJSValue;
    procedure SetCellByFieldName(DisplayedRowIndex: TJSValue; FieldName: String; const Value: TJSValue);
    function GetCellById(RowID: TJSValue; ColumnIndex: Integer): TJSValue;
    procedure SetCellById(RowID: TJSValue; ColumnIndex: Integer; const Value: TJSValue);
    function GetCellByIndex(AbsoluteRowIndex: Integer; ColumnIndex: Integer): TJSValue;
    procedure SetCellByIndex(AbsoluteRowIndex: Integer; ColumnIndex: Integer; const Value: TJSValue);
    function GetCellByDisplayedRowIndex(DisplayedRowIndex, ColumnIndex: Integer): TJSValue;
    procedure SetCellByDisplayedRowIndex(DisplayedRowIndex, ColumnIndex: Integer; const Value: TJSValue);
    procedure SetSuppressMoveWhenColumnDragging(const Value: Boolean);
    procedure SetRowHeight(const Value: Integer);
    procedure SetEnableClickSelection(const Value: Boolean);
    function GetRowSelected(RowIndex: Integer): Boolean;
    procedure SetRowSelected(RowIndex: Integer; const Value: Boolean);
    function GetDisplayedRowSelected(DisplayedRowIndex: Integer): Boolean;
    procedure SetDisplayedRowSelected(DisplayedRowIndex: Integer; const Value: Boolean);
{$IFNDEF DESIGNER}
    function GetRowCount: Integer;
{$ENDIF DESIGNER}
    function GetAllCells(RowIndex: Integer; ColumnIndex: Integer): String;
    procedure SetAllCells(RowIndex: Integer; ColumnIndex: Integer; const Value: String);
    function GetCells(DisplayedRowIndex: Integer; ColumnIndex: Integer): String;
    procedure SetCells(DisplayedRowIndex: Integer; ColumnIndex: Integer;
      const Value: String);
    function GetAllFloats(RowIndex: Integer; ColumnIndex: Integer): Double;
    function GetFloats(DisplayedRowIndex: Integer; ColumnIndex: Integer): Double;
    procedure SetAllFloats(RowIndex: Integer; ColumnIndex: Integer; const Value: Double);
    procedure SetFloats(DisplayedRowIndex: Integer; ColumnIndex: Integer;
      const Value: Double);
    function AddRootHeaderObject(ToArr: TJSArray; RootHeader: TJSObject): Boolean;
    procedure SetLocale(const Value: TDGLocale);
    procedure SetOnGetLocaleText(const Value: TDGGetLocaleTextCallBack);

    function GetFilterModel: TJSValue;
    procedure SetFilterModel(const Value: TJSValue);

  protected
    procedure SetServerDataAdapter(const Value: TDGServerDataAdapter); virtual;



  protected
    FPropertySerializer: TJSPropertySerializer;
    FAGGrid: TJSAgGrid;
    FAGGridLocale: TJSAgGridLocale;
    FColumnDefs: TDGColumnDefsCollection;
    FGridId: String;


    FInChangeTransaction: Boolean;

    FCreateInitialized: Boolean;
    procedure OnCreateInitialize;
    procedure CreateColumnDefs; virtual;
    procedure FreeColumnDefs; virtual;


{$IFNDEF DESIGNER}
    function GetJsonPropertiesString(IncludeUrl: Boolean = true) : String;
    function GetGridOptions: TJSObject;
    procedure FillProperties(Props: TJSPropertySerializer; IncludeUrl: Boolean = True); virtual;
    procedure FillEvents(Props: TJSPropertySerializer; IncludeUrl: Boolean = True); virtual;
    function GetJsonProperties(IncludeUrl: Boolean = True): TJSObject;
    function GetFullName(Component: TComponent): String;
    function GetLocaleText(): TJSObject;
{$ENDIF}
    function GetRowData: TJSArray;
    procedure SetRowData(const Value: TJSArray);
    procedure OnPaginationChanged(Event: TJSPaginationChangedEvent);

    procedure OnBandingChanged(Sender: TObject); virtual;
    procedure OnThemingChanged(Sender: TObject); virtual;
    procedure OnDefaultColDefChanged(Sender: TObject); virtual;

    procedure HandleOnRowSelectedEvent(Event: TJSRowSelectedEvent); virtual;
    procedure HandleOnCellValueChanged(Params: TJSCellEditingEvent); virtual;
    procedure HandleOnCellEditingStarted(Params: TJSCellEditingEvent); virtual;
    procedure HandleOnCellEditingStopped(Params: TJSCellEditingEvent); virtual;
    procedure HandleOnRowEditingStarted(Params: TJSRowEditingEvent); virtual;
    procedure HandleOnRowEditingStopped(Params: TJSRowEditingEvent); virtual;
    function HandleTabToNextCell(Params: TJSTabToNextCellParams): TJSValue; virtual;
    procedure HandleOnPaginationChanged(Event: TJSPaginationChangedEvent); virtual;
    procedure HandleOnSelectionChanged(Event: TJSSelectionChangedEvent); virtual;
    procedure HandleOnSortChanged(Event: TJSSortChangedEvent); virtual;
    procedure HandleOnFilterChanged(Event: TJSFilterChangedEvent); virtual;
    procedure HandleOnCellClickedEvent(Event: TJSCellClickedEvent); virtual;
    procedure HandleOnCellDoubleClickedEvent(Event: TJSCellDoubleClickedEvent); virtual;
    procedure HandleOnCellFocusedEvent(Event: TJSCellFocusedEvent); virtual;
    procedure HandleOnCellMouseOverEvent(Event: TJSCellMouseDownEvent); virtual;
    procedure HandleOnCellMouseDown(Event: TJSCellMouseDownEvent); virtual;

    function HandleOnGetRowStyleCallback(Params: TJSGetRowStyleParams): TJSObject; virtual;
    function HandleOnGetRowClassCallback(Params: TJSGetRowClassParams): TJSValue; virtual;
    function HandleOnGetRowHeightCallback(Params: TJSRowHeightParams): TJSObject; virtual;

    function HandleOnGetLocaleText(Params: TJSGetLocaleTextParams): string; virtual;

    procedure HandleDSPaginationChanged(Sender: TComponent;
        CurrentPage: Integer; PaginationSize: Integer); virtual;
    procedure HandleDSDataChanged(Sender: TComponent); virtual;

    procedure Notification(AComponent: TComponent; Operation: TOperation); override;
{$IFDEF DESIGNER}
    procedure ColWidthsChanged; override;
{$ENDIF}

  protected
    function CreateElement: TJSElement; override;
    procedure Loaded; override;
{$IFDEF DESIGNER}
    function __ConvertName(Value: String): String;
    procedure _UpdateColumnDefs(Sender: TObject);
    procedure _OnColumnDefsChanged(Sender: TObject);
    procedure _OnColumnDefsItemChanged(Sender: TObject);
{$ENDIF}

    procedure UpdateElement; {$IFDEF PAS2JS}override;{$ENDIF}  // Gets called multiple times...

    function FindFirstChildElement(TagName: String; CurrentElement: TJSHTMLElement): TJSHTMLElement;

    procedure OnColumnDefsChanged(Sender: TObject); virtual;
    procedure OnBeforeColumnDefsUpdate(ColumnDefs: TJSArray; var Handled: Boolean); virtual;

    procedure EnsureLastRowVisible; virtual;
    function DeleteSelectedRows: Boolean; virtual;
    function InsertNewRow: Boolean; virtual;

    procedure DoOptionsChange(OptionName: String; OptionValue: TJSValue);

    procedure AddColumn(Item: TDGCollectionItem; Arr: TJSArray); virtual;

  public
    procedure CreateInitialize; override;
    constructor Create(AOwner: TComponent); overload; override;
    destructor Destroy; override;

{$IFNDEF DESIGNER}
    procedure LoadGrid;
{$ENDIF}
    procedure RecreateGrid;
    function IsLoading: Boolean;

{$IFDEF DESIGNER}
    function ColumnDefsCount: Integer; override;
{$ENDIF}
    procedure Clear;
    procedure RefreshGrid;
    function SetSelectedRow(RowIndex: Integer; Selected: Boolean): Boolean;

    function FindFirstSelectedRowNode: TJSRowNode;
    function FindFirstSelectedRowIndex: Integer;
    function FindFirstSelectedDisplayedRowIndex: Integer;
    function FindFirstSelectedRowId: String;


    property AGGrid: TJSAgGrid read FAGGrid;
    property RowData: TJSArray read GetRowData write SetRowData;
{$IFNDEF DESIGNER}
    property RowCount: Integer read GetRowCount;
{$ENDIF DESIGNER}
    property RowDataByName[RowID: TJSValue; FieldName: String]: TJSValue read GetRowDataByFieldName write SetRowDataByFieldName;
    property RowDataByID[RowID: TJSValue; ColumnIndex: Integer]: TJSValue read GetRowDataById write SetRowDataById;
    property CellByName[DisplayedRowIndex: TJSValue; FieldName: String]: TJSValue read GetCellByFieldName write SetCellByFieldName;
    property CellByID[RowID: TJSValue; ColumnIndex: Integer]: TJSValue read GetCellById write SetCellById;
//    property CellByIndex[RowID: TJSValue; ColumnIndex: Integer]: TJSValue read GetCellByIndex write SetCellByIndex;
    property AllCells[RowIndex: Integer; ColumnIndex: Integer]: String read GetAllCells write SetAllCells;
    property AllFloats[RowIndex: Integer; ColumnIndex: Integer]: Double read GetAllFloats write SetAllFloats;
    property Cells[DisplayedRowIndex: Integer; ColumnIndex: Integer]: String read GetCells write SetCells;
    property Floats[DisplayedRowIndex: Integer; ColumnIndex: Integer]: Double read GetFloats write SetFloats;
    property MultilevelHeaders: TDGMultilevelHeaderCollection read FMultilevelHeaders write FMultilevelHeaders;
    property ColumnDefs: TDGColumnDefsCollection read FColumnDefs write FColumnDefs;
    property ServerDataAdapter: TDGServerDataAdapter read FServerDataAdapter write SetServerDataAdapter;
    property RowSelected[RowIndex: Integer]: Boolean read GetRowSelected write SetRowSelected;
    property DisplayedRowSelected[DisplayedRowIndex: Integer]: Boolean read GetDisplayedRowSelected write SetDisplayedRowSelected;
    property Locale: TDGLocale read FLocale write SetLocale default localeNone;

    property FilterModel: TJSValue read GetFilterModel write SetFilterModel;

{$REGION 'Unpublished Events'}
    property OnRowSelected: TDGRowSelectedCallBack read FOnRowSelected write FOnRowSelected;
    property OnRowUnselected: TDGRowSelectedCallBack read FOnRowUnselected write FOnRowUnselected;
    property OnCellEditingStarted: TDGCellEditingEvent read FOnCellEditingStarted write FOnCellEditingStarted;
    property OnCellEditingEnded: TDGCellEditingEvent read FOnCellEditingEnded write FOnCellEditingEnded;
    property OnRowEditingStarted: TDGRowEditingEvent read FOnRowEditingStarted write FOnRowEditingStarted;
    property OnRowEditingEnded: TDGRowEditingEvent read FOnRowEditingEnded write FOnRowEditingEnded;
    property TabToNextCell: TDGTabToNextCellEvent read FOnTabToNextCell write FOnTabToNextCell;

    property OnCellClickedEvent: TDGCellClickedEvent read FOnCellClickedEvent write FOnCellClickedEvent;
    property OnCellDoubleClickedEvent: TDGCellDoubleClickedEvent read FOnCellDoubleClickedEvent write FOnCellDoubleClickedEvent;
    property OnCellFocusedEvent: TDGCellFocusedEvent read FOnCellFocusedEvent write FOnCellFocusedEvent;
    property OnCellMouseOverEvent: TDGCellMouseOverEvent read FOnCellMouseOverEvent write FOnCellMouseOverEvent;
    property OnCellMouseDown: TDGCellMouseDown read FOnCellMouseDown write FOnCellMouseDown;

    property OnGetLocaleText: TDGGetLocaleTextCallBack read FOnGetLocaleText write SetOnGetLocaleText;
{$ENDREGION}
  published
    property Banding: TDGBanding read FBanding write FBanding;
    property Theming: TDGTheming read FTheming write FTheming;
    property DefaultColDef: TDGDefaultColDef read FDefaultColDef write FDefaultColDef;

    property Pagination: Boolean read FPagination write SetPagination default False;
    property PaginationAutoPageSize: Boolean read FPaginationAutoPageSize write SetPaginationAutoPageSize default True;
    property PaginationPageSize: Integer read FPaginationPageSize write SetPaginationPageSize default 20;
    property PaginationPageSizeSelector: String read FPaginationPageSizeSelector write SetPaginationPageSizeSelector;
    property CacheBlockSize: Integer read FCacheBlockSize write SetCacheBlockSize default 100;
    property MaxBlocksInCache: Integer read FMaxBlocksInCache write SetMaxBlocksInCache;
    property TabOrder;
    property TabStop;
    property RowSelection: TDGRowSelectionType read FRowSelection write SetRowSelection default rsSingle;
    property RowMultiSelectWithClick: Boolean read FRowMultiSelectWithClick write SetRowMultiSelectWithClick;

    property EnableClickSelection: Boolean read FEnableClickSelection write SetEnableClickSelection;
    property EditType: TDGRowEditType read FEditType write SetEditType default retCell;
    property BidiMode: TBiDiMode read FBidiMode write SetBidiMode;
    property SuppressMoveWhenColumnDragging: Boolean read FSuppressMoveWhenColumnDragging write SetSuppressMoveWhenColumnDragging;
    property RowHeight: Integer read FRowHeight write SetRowHeight default 0;

    property Align;
    property Anchors;
//    property Font;  //AC:20240713 - To be implemented since changing fonts in AG-Grid involves CSS changes
    property Font stored IsFontStored;

{$REGION 'Published Events'}
    property OnSelectionChanged: TDGSelectionChangedEvent read FOnSelectionChanged write FOnSelectionChanged;
    property OnGetRowStyle: TDGGetRowStyleCallback read FOnGetRowStyle write FOnGetRowStyle;
    property OnGetRowClass: TDGGetRowClassCallback read FOnGetRowClass write FOnGetRowClass;
    property OnGetRowHeight: TDGGetRowHeightCallback read FOnGetRowHeight write FOnGetRowHeight;
{$ENDREGION}
{$REGION 'Designer Compatability'}
  published
    property Center;
    property ElementID;
    property HeightStyle;
    property HeightPercent;
    property WidthStyle;
    property WidthPercent;
{$ENDREGION}

  end;

  TDataGridCustom = class(TDataGridBase)
  private
    FReq: TJSXMLHttpRequest;
    FDataNode: string;
    FOnHttpRequestError: TNotifyEvent;
    FOnHttpRequest: TDataGridRequestEvent;
    FOnHttpRequestSuccess: TNotifyEvent;

    FDelimiter: char;
    FQuoteChar: char;
    FFirstRowColumnLabels: boolean;

  protected
    property OnHttpRequestError: TNotifyEvent read FOnHttpRequestError write FOnHttpRequestError;
    property OnHttpRequestSuccess: TNotifyEvent read FOnHttpRequestSuccess write FOnHttpRequestSuccess;
    property OnHttpRequest: TDataGridRequestEvent read FOnHttpRequest write FOnHttpRequest;

    function DoHttpLoadJson(Event: TEventListenerEvent): boolean; virtual;
    function DoHttpLoadCsv(Event: TEventListenerEvent): boolean; virtual;
    function DoHttpAbort(Event: TEventListenerEvent): boolean; virtual;
    procedure DoHttpRequest(ARequest: TJSXMLHttpRequest); virtual;
    procedure LoadFromStringList(AStrings: TStrings);

  public

    procedure LoadFromJSON(const AURL: string; ADataNode: string = ''); overload;
    procedure LoadFromJSON(AJSON: TJSObject; ADataNode: string = ''); overload;
    function LoadFromJSONAsync(const AURL: string; ADataNode: string = ''): TJSPromise;
    procedure LoadFromCSV(const AURL: string; Delimiter: char = ';'; FirstRowColumnLabels: boolean = false);
    function LoadFromCSVAsync(const AURL: string; Delimiter: char = ';'; FirstRowColumnLabels: boolean = false): TJSPromise;
    procedure LoadFromCSVString(const CSVString: string; Delimiter: char = ','; Quote: char = '"'; FirstRowColumnLabels: boolean = false);
    procedure LoadFromStrings(AStrings: TStrings; Delimiter: char = ';'; Quote: char = #0; FirstRowColumnLabels: boolean = false);
    procedure SaveToCSV(const AFileName: string; Delimiter: char = ';'; Quote: char = #0; FirstRowColumnLabels: boolean = false);
    function SaveAsCSVToString(Delimiter: char = ','; Quote: char = '"'; FirstRowColumnLabels: boolean = false): String;
    procedure SaveToStrings(AStrings: TStrings; Delimiter: char = ';'; Quote: char = #0; FirstRowColumnLabels: boolean = false);
  end;

  TDataGrid = class(TDataGridCustom)
  public
    procedure EnsureLastRowVisible; override;
    function DeleteSelectedRows: Boolean; override;
    function InsertNewRow: Boolean; override;

  published
    property MultilevelHeaders;
    property ColumnDefs;

    property ServerDataAdapter;

    property Visible;
    property OnRowSelected;
    property OnRowUnselected;
    property OnCellEditingStarted;
    property OnCellEditingEnded;
    property OnRowEditingStarted;
    property OnRowEditingEnded;

    property OnCellClickedEvent;
    property OnCellDoubleClickedEvent;
    property OnCellFocusedEvent;
    property OnCellMouseOverEvent;
    property OnCellMouseDown;

    property OnGetLocaleText;

    property PopupMenu;
    property Locale;
  end;

{$IFNDEF PAS2JS}
  [ComponentPlatforms(TMSWebPlatform)]

{$ENDIF}
  {NOPP} TWebDataGrid = class(TDataGrid);

{$ENDREGION}

{$REGION 'DataGridSearch'}
  TDataGridSearch = class(TCustomEdit)
  private
    FSearchGrid: TDataGridBase;
    FPlaceHolder: String;
    FIsLoaded: Boolean;

    procedure SetSearchGrid(const Value: TDataGridBase);
  protected
    function DoHandleChange(Event: TEventListenerEvent): Boolean; {$IFDEF PAS2JS}override;{$ENDIF}
    procedure ApplyQuickFilter; virtual;

    procedure Notification(AComponent: TComponent; Operation: TOperation); override;
    procedure Loaded; override;
  public

    procedure Load;

  published
    property SearchGrid: TDataGridBase read FSearchGrid write SetSearchGrid;
    property OnChange;
    property PlaceHolder: String read FPlaceHolder write FPlaceHolder;
    property TabOrder;
  end;

  {$IFNDEF PAS2JS}
  [ComponentPlatforms(TMSWebPlatform)]
  {$ENDIF}
  {NOPP} TWebDataGridSearch = class(TDataGridSearch);  // NOPP
{$ENDREGION}

implementation

type
  TDGServerDataAdapterInternal = class(TDGServerDataAdapter)
  {$IFNDEF PAS2JS}
  public

    procedure UpdateRow(DataGrid: TComponent; RowData: TJSObject; Callback: TDGServerDSCallback = nil; ErrorCallBack: TDGServerDSErrorCallback = nil); reintroduce; virtual; abstract; {$IFDEF PAS2JS}async;{$ENDIF}
  {$ENDIF}
  end;



{$REGION 'DataGrid'}
{ TDataGrid }

{$REGION 'Creation and Destruction'}
constructor TDataGridBase.Create(AOwner: TComponent);
var
  I: Integer;
begin
  inherited Create(AOwner);
  OnCreateInitialize;



  // Add default columns at Bruno's request
  if (csDesigning in ComponentState) and not
     ((csReading in AOwner.ComponentState) or
     (csLoading in AOwner.ComponentState)) then
  begin
    for I := 0 to 1 do
    begin
      with FColumnDefs.Add do
      begin
        Field := 'column' + IntToStr(I + 1);
      end;
    end;
  end;
end;

destructor TDataGridBase.Destroy;
begin

  if Assigned(FBanding) then FreeAndNil(FBanding);
  if Assigned(FTheming) then FreeAndNil(FTheming);
  if Assigned(FDefaultColDef) then FreeAndNil(FDefaultColDef);
  FreeColumnDefs;
  if Assigned(FServerDataAdapter) then
  begin
    // Unregister the handler from the server data source.
    FServerDataAdapter.UnregisterPaginationChangeHandler({$IFDEF PAS2JS}@{$ENDIF}HandleDSPaginationChanged);
    FServerDataAdapter.UnregisterDataChangeHandler({$IFDEF PAS2JS}@{$ENDIF}HandleDSDataChanged);

    FServerDataAdapter := nil;
  end;

  if Assigned(FAGGrid) then
  begin
    FAGGrid._destroy;
    FAGGrid := nil;
  end;
  inherited;
end;

procedure TDataGridBase.CreateColumnDefs;
begin
  FColumnDefs := TDGColumnDefsCollection.Create(Self);
  FColumnDefs.RegisterCallback({$IFDEF PAS2JS}@{$ENDIF}OnColumnDefsChanged);
{$IFDEF DESIGNER}
  FColumnDefs.OnChange := _OnColumnDefsChanged;
  _UpdateColumnDefs(nil);
{$ENDIF}
end;

procedure TDataGridBase.FreeColumnDefs;
begin
  if Assigned(FColumnDefs) then FreeAndNil(FColumnDefs);
end;

procedure TDataGridBase.DoOptionsChange(OptionName: String; OptionValue: TJSValue);
begin
  if (not FInChangeTransaction) and
     Assigned(FAgGrid) then
    FAGGrid.setGridOption(OptionName, OptionValue);
end;

procedure TDataGridBase.EnsureLastRowVisible;
var
  PageSize, CurrentPage, SelectPage, RowCount: Integer;
begin
  if Assigned(FAGGrid) then
  begin
    PageSize := FAGGrid.paginationGetPageSize;
    CurrentPage := FAGGrid.paginationGetCurrentPage;
    RowCount := FAGGrid.getInfiniteRowCount;
    SelectPage := Floor(RowCount / PageSize);
    if SelectPage <> CurrentPage then
      FAGGrid.paginationGoToPage(SelectPage);
    FAGGrid.ensureIndexVisible(RowCount - 1);
  end;
end;

procedure TDataGridBase.CreateInitialize;
begin
  inherited;
  OnCreateInitialize;

end;

procedure TDataGridBase.OnCreateInitialize;
var
  __agGridLocale__: Pointer;
begin
  _nowarn(__agGridLocale__);

  if not FCreateInitialized then
  begin

    FCreateInitialized := True;

{$IFNDEF DESIGNER}

    // Enable mouse event propagation so it will read the underlying AG-Grid
    EventStopPropagation := EventStopPropagation - [eeMouseDown, eeMouseUp, eeMouseMove];

    TTMSModuleLoader.AddModule('TEmbeddedJSAgGrid', 'js/aggrid.js');
    TTMSModuleLoader.AddModule('TDGCellComponents', 'js/tms-cell-components.js', ''{$IFDEF CELLCOMPONENTS_DEBUG}, True{$ENDIF});
    TTMSModuleLoader.AddModule('TEmbeddedJSAgGridLocale', 'js/locale.js');
    TTMSModuleLoader.AddModule('TDGGridInjections', 'js/tms-grid-injections.js');
    TTMSModuleLoader.LoadModules(csDesigning in ComponentState);

    // Load AG-Grid locale information
    __agGridLocale__ := getAgGridApi(csDesigning in ComponentState, 'agGridLocale');
    if _typeof(__agGridLocale__) = 'undefined' then
      raise Exception.Create('Error: Unable to get AG-Grid Locale API!');
    asm { this.FAGGridLocale = __agGridLocale__ } end;
{$ENDIF}


    CreateColumnDefs;
    FMultilevelHeaders := TDGMultilevelHeaderCollection.Create(Self);
    FInChangeTransaction := False;
    FBanding := TDGBanding.Create;
    FBanding.RegisterCallback({$IFDEF PAS2JS}@{$ENDIF}OnBandingChanged);
    FTheming := TDGTheming.Create;
    FTheming.RegisterCallback({$IFDEF PAS2JS}@{$ENDIF}OnThemingChanged);
    FDefaultColDef := TDGDefaultColDef.Create;
    FDefaultColDef.RegisterCallback({$IFDEF PAS2JS}@{$ENDIF}OnDefaultColDefChanged);

    FPagination := False;
    FPaginationAutoPageSize := True;
    FPaginationPageSize := 20;
    FCacheBlockSize := 100;
    FMaxBlocksInCache := 0;
    FRowSelection := rsSingle;
    FRowMultiSelectWithClick := false;

    FEnableClickSelection := true;
    FEditType := retCell;

    InitFont(Font);

    Width := 400;
    Height := 200;

  end;

end;

procedure TDataGridBase.OnDefaultColDefChanged(Sender: TObject);
var
  DefaultColDef: TDGDefaultColDef;
begin
  if Assigned(FAgGrid) and Assigned(Sender) then
  begin
    DefaultColDef := TDGUtils.AsType<TDGDefaultColDef>(Sender);
    if Assigned(DefaultColDef) then
    begin
//      UpdateElement;
    end;
  end;
end;

procedure TDataGridBase.OnPaginationChanged(Event: TJSPaginationChangedEvent);
var
  pageSize, currentPage: Integer;
begin
  if Assigned(FAGGrid) and
     (ServerDataAdapter <> nil) then
  begin

    if (Event.NewPageSize = True) or
       (Event.NewPage) then
    begin
      pageSize := FAGGrid.paginationGetPageSize;
      currentPage := FAGGrid.paginationGetCurrentPage;
      TDGServerDataAdapterInternal(ServerDataAdapter).UpdatePaginationParameters(Self, currentPage, pageSize);
    end;

  end;
end;


procedure TDataGridBase.Notification(AComponent: TComponent;
  Operation: TOperation);
begin
  inherited Notification(AComponent, Operation);
  if Operation = opRemove then
  begin
    if AComponent = FServerDataAdapter then
      FServerDataAdapter := nil;
  end;
end;

{$ENDREGION}

{$REGION 'Initialization'}
function TDataGridBase.CreateElement: TJSElement;
var
  InnerElement: TJSHTMLElement;
begin

  if (csDesigning in ComponentState) then
  begin
    Result := document.createElement('DIV');
    InnerElement := TJSHTMLElement(document.createElement('DIV'));
    InnerElement.innerHTML := Name;
    InnerElement['align'] := 'center';
    InnerElement.style.setProperty('border','1px solid gray');
    InnerElement.style.setProperty('vertical-align','middle');
    InnerElement.style.setProperty('height','100%');
    InnerElement.style.setProperty('width','100%');
    TJSHTMLElement(Result).style.setProperty('background-color','red');
    Result.appendChild(InnerElement);
  end
  else
  begin
    Result := document.createElement('DIV');

    TJSHTMLElement(Result).style.setProperty('width', IntToStr(Width) + 'px');
    TJSHTMLElement(Result).style.setProperty('height', IntToStr(Height) + 'px');

  end;
end;


procedure TDataGridBase.UpdateElement;
var
    DivElement, StyleElement: TJSHTMLElement;
    Style: String;
begin

  inherited;

  if IsUpdating then
    Exit;

  if (csDestroying in ComponentState) then
    Exit;

  if not Assigned(ElementHandle) then
    Exit;

  if Assigned(ElementHandle) then
  begin
    ElementHandle.style.setProperty('overflow', '');

    // Update element DIV
    DivElement := TJSHTMLElement(ElementHandle);
    if Assigned(DivElement) then
    begin
      // Look for existing style element
      StyleElement := FindFirstChildElement('STYLE', DivElement);

      if StyleElement = nil then
      begin
        // Create new style element
        StyleElement := TJSHTMLElement(document.createElement('STYLE'));
        DivElement.appendChild(StyleElement);
      end;

      Style := '';
      if Assigned(FBanding) and FBanding.Enabled then
      begin
        Style := Style
          + '.ag-row-odd { background-color: #' + TDGUtils.TColorToHex(FBanding.OddRowsColor) + '; }' + #$D#$A
          + '.ag-row-even { background-color: #' + TDGUtils.TColorToHex(FBanding.EvenRowsColor) + '; } ' + #$D#$A
        ;
      end;
      if Assigned(FTheming) and FTheming.Enabled then
      begin
        Style := Style
          + '.' + FTheming.GetThemeClass + ' {' + #$D#$A
          + '  --ag-font-family: ' + Font.Name + #$D#$A
          + '}' + #$D#$A;
      end;
      StyleElement.innerHTML := Style;
    end;
  end;
end;


{$REGION 'Loading'}
// The Loaded procedure is called by the code generated by the
// TMSWebCompiler.exe.  It is called twice when loading using DFM,
// and only once when the object is instantiated manually.  Originally,
// I used the end EndUpdate callback which was only called once after
// this.AfterLoadDFMValues() in the generated JavaScript, but EndUpdate
// is not called when the object is instantiated manually.  Hence I am
// using FAfterLoadDFMValues to filter out the extra call.
procedure TDataGridBase.Loaded;
begin

  inherited;
{$IFDEF DESIGNER}
  _OnColumnDefsChanged(Self);
  Exit;
{$ENDIF}

  if not (csLoading in ComponentState) then
  begin

    if not Assigned(ElementHandle) then
      Exit;


{$IFNDEF DESIGNER}
    LoadGrid;
{$ENDIF}
  end;
end;

{$IFNDEF DESIGNER}
function TDataGridBase.GetElementID: String;
begin
  Result := ElementID;
  if Trim(Result) = '' then
  begin
    // ElementID is empty...  Try using Name instead
    Result := Name;
    if Trim(Result) = '' then
    begin
      // Both ElementID and Name are empty
      Result := 'DataGridId-' + IntToStr(Random(10000));
    end;
  end;
end;

procedure TDataGridBase.LoadGrid;
var
  DivElement: TJSHTMLElement;
  NewElement: TJSHTMLElement;
  FirstChildElement: TJSHTMLElement;
  GridElement: TJSElement;
  GridSelector, WrapperId: String;
  GridClass: String;
  GridOptions: TJSObject;
  PS: TJSPropertySerializer;
  __agGrid__: Pointer;
begin
  if FIsLoaded then
    Exit
  else
  begin
    if Assigned(ServerDataAdapter) and
       (ColumnDefs.Count = 0) and
       (not FIsSchemaAttempted) then
    begin
      //AC: Handling auto schema loading here
      FIsSchemaAttempted := True;
      ServerDataAdapter.LoadSchema(
        ColumnDefs,
        procedure
        begin
          LoadGrid;
        end,
        procedure
        begin
          // Schema loading failed - load the grid anyway
          LoadGrid;
        end
      );
      Exit;
    end;
    FIsLoaded := True;
  end;

  FGridId := 'myGrid';
  GridClass := ''; //AC: 'ag-theme-alpine';
  if FTheming.Enabled then
  begin
    GridClass := FTheming.GetThemeClass;
  end;

  DivElement := TJSHTMLElement(ElementHandle);
  if Assigned(DivElement) then
  begin
    try
      WrapperId := GetElementID;

      if Trim(DivElement.id) = '' then
        DivElement.id := WrapperId;

      FirstChildElement := FindFirstChildElement('DIV', DivElement);
      if _NotNullOrUndefined(FirstChildElement) then
        DivElement := TJSHTMLElement(DivElement.firstElementChild);


      NewElement := TJSHTMLElement(document.createElement('DIV'));
      DivElement.appendChild(NewElement);
      PS := TJSPropertySerializer.Create;
      FillProperties(PS, True);
      FGridId := WrapperId + '-grid';
      GridSelector := '#' + FGridId;
      NewElement['id'] := FGridId;
      if GridClass <> '' then
        NewElement['class'] := GridClass;
      NewElement.style.setProperty('height', '100%');

      GridElement := document.querySelector(GridSelector);
      GridOptions := PS.AsJsObject(True);

      __agGrid__ := getAgGridApi(csDesigning in ComponentState);
      if _typeof(__agGrid__) = 'undefined' then
        raise Exception.Create('Error: Unable to get AG-Grid API!');

      // Load the grid injections
      TEmbeddedJSInjections.LoadInjectionModule(__agGrid__);

      FAGGrid := TJSAgGrid.createGrid(GridElement, GridOptions);

      // Init the grid injections
      TEmbeddedJSInjections.InitInjectionModule(Self, FAGGrid);


      FColumnDefs.ApplyChanges;
      FTheming.ApplyChanges;

      if csDesigning in ComponentState then
        FAGGrid.hideOverlay;

{$IFDEF OBSOLETE}
      if Assigned(ServerDataAdapter) then
        ServerDataAdapter.AGGrid := FAGGrid;
{$ENDIF}
    finally
      FreeAndNil(PS);
    end;
  end;
end;
{$ENDIF}

procedure TDataGridBase.RecreateGrid;
var
  GridElement: TJSElement;
  GridOptions: TJSObject;
  __agGrid__: Pointer;
  ReloadData: TJSArray;
  CurrentPageSize, CurrentPage: Integer;
begin
  if Assigned(FAGGrid) then
  begin
    ReloadData := TJSArray._of;
    if not Assigned(ServerDataAdapter) then
      ReloadData := RowData;

    CurrentPageSize := FAGGrid.paginationGetPageSize;
    CurrentPage := FAGGrid.paginationGetCurrentPage;

    FAGGrid._destroy;
    asm { delete this.FAGGrid; this.FAGGrid = undefined; } end;

    GridElement := document.querySelector('#' + FGridId);
{$IFNDEF DESIGNER}
    GridOptions := GetGridOptions;
{$ELSE}
    GridOptions := nil;
{$ENDIF}
    __agGrid__ := getAgGridApi(csDesigning in ComponentState);
    if _typeof(__agGrid__) = 'undefined' then
      raise Exception.Create('Error: Unable to get AG-Grid API!');
    FAGGrid := TJSAgGrid.createGrid(GridElement, GridOptions);

    if Assigned(ServerDataAdapter) then
    begin
      RefreshGrid;
      TDGServerDataAdapterInternal(ServerDataAdapter).UpdatePaginationParameters(Self, CurrentPage, CurrentPageSize);
    end
    else
    begin
      RowData := ReloadData;
      FAGGrid.setGridOption('paginationPageSize', CurrentPageSize);
      FAGGrid.paginationGoToPage(CurrentPage);
    end;
  end;
end;

procedure TDataGridBase.OnBandingChanged(Sender: TObject);
var
  Banding: TDGBanding;
begin
  if Assigned(FAgGrid) and Assigned(Sender) then
  begin
    Banding := TDGUtils.AsType<TDGBanding>(Sender);
    if Assigned(Banding) then
    begin
      UpdateElement;
    end;
  end;
end;

procedure TDataGridBase.OnBeforeColumnDefsUpdate(ColumnDefs: TJSArray;
var Handled: Boolean);
begin
  // Do nothing here. :)
end;

procedure TDataGridBase.OnThemingChanged(Sender: TObject);
var
  DivElement, SubDivElement: TJSHTMLElement;
  StyleClass: String;
  Theming: TDGTheming;
begin
 if Assigned(FAgGrid) and Assigned(Sender) and Assigned(ElementHandle) then
  begin
    Theming := TDGUtils.AsType<TDGTheming>(Sender);
    if Assigned(Theming) then
    begin
      DivElement := TJSHTMLElement(ElementHandle);
      if Assigned(DivElement) then
      begin
        SubDivElement := FindFirstChildElement('DIV', DivElement);
        if Assigned(SubDivElement) then
        begin
          StyleClass := '';
          if FTheming.Enabled then
            StyleClass := FTheming.GetThemeClass;
          if StyleClass <> '' then
            SubDivElement['class'] := StyleClass;
        end;
      end;
    end;
  end;
end;

procedure TDataGridBase.RefreshGrid;
begin
  if Assigned(FAGGrid) then
  begin
    if Assigned(ServerDataAdapter) then
    begin
      if ColumnDefs.Count = 0 then
      begin
        //AC: Handling auto schema loading here
        ServerDataAdapter.LoadSchema(
          ColumnDefs,
          procedure
          begin
            FAGGrid.refreshInfiniteCache
          end
        );
        Exit;
      end;
      FAGGrid.refreshInfiniteCache
    end
    else
      raise Exception.Create('Error: RefreshGrid can only be called when the ServerDataAdapter has been assigned!');
  end;
end;



procedure TDataGridBase.SetCacheBlockSize(const Value: Integer);
begin
  FCacheBlockSize := Value;
  DoOptionsChange('cacheBlockSize', FCacheBlockSize);
end;

function TDataGridBase.GetCellById(RowID: TJSValue; ColumnIndex: Integer): TJSValue;
begin
  Result := '';

  if (ColumnIndex >= 0) and
     (ColumnIndex < FColumnDefs.Count) then
  begin
    Result := GetRowDataByFieldName(RowID, FColumnDefs[ColumnIndex].Field);
  end
  else
  raise Exception.Create('Error: Invalid ColumnIndex provided.');
end;

function TDataGridBase.GetCellByIndex(AbsoluteRowIndex: Integer; ColumnIndex: Integer): TJSValue;
begin
  if Assigned(ServerDataAdapter) then
    Result := GetCellById(IntToStr(AbsoluteRowIndex), ColumnIndex)
  else
    Result := GetCellById(AbsoluteRowIndex, ColumnIndex);
end;

function TDataGridBase.GetCellByDisplayedRowIndex(DisplayedRowIndex: Integer;
  ColumnIndex: Integer): TJSValue;
begin
  Result := '';

  if (ColumnIndex >= 0) and
     (ColumnIndex < FColumnDefs.Count) then
  begin
    Result := GetCellByFieldName(DisplayedRowIndex, FColumnDefs[ColumnIndex].Field);
  end
  else
  raise Exception.Create('Error: Invalid ColumnIndex provided.');
end;

function TDataGridBase.GetCells(DisplayedRowIndex: Integer;
  ColumnIndex: Integer): String;
var
  CellValue: TJSValue;
begin
  Result := '';
  CellValue := GetCellByDisplayedRowIndex(DisplayedRowIndex, ColumnIndex);
  if _NotNullOrUndefined(CellValue) then
    Result := String(CellValue);
end;

function TDataGridBase.GetDisplayedRowSelected(
  DisplayedRowIndex: Integer): Boolean;
var
  RowNode: TJSRowNode;
begin
  Result := False;
  if Assigned(FAGGrid) then
  begin
    RowNode := FAGGrid.getDisplayedRowAtIndex(DisplayedRowIndex);

    if _NotNullOrUndefined(RowNode) then
    begin
      Result := RowNode.isSelected;
    end;
  end;
end;

procedure TDataGridBase.SetCellById(RowID: TJSValue; ColumnIndex: Integer;
  const Value: TJSValue);
begin
  if (ColumnIndex >= 0) and
     (ColumnIndex < FColumnDefs.Count) then
  begin
    SetRowDataByFieldName(RowId, FColumnDefs[ColumnIndex].Field, Value);
  end
  else
  raise Exception.Create('Error: Invalid ColumnIndex provided.');
end;

procedure TDataGridBase.SetCellByIndex(AbsoluteRowIndex: Integer; ColumnIndex: Integer;
  const Value: TJSValue);
begin
  if Assigned(ServerDataAdapter) then
    SetCellById(IntToStr(AbsoluteRowIndex), ColumnIndex, Value)
  else
    SetCellById(AbsoluteRowIndex, ColumnIndex, Value);
end;

procedure TDataGridBase.SetCellByDisplayedRowIndex(DisplayedRowIndex: Integer;
  ColumnIndex: Integer; const Value: TJSValue);
begin
  if (ColumnIndex >= 0) and
     (ColumnIndex < FColumnDefs.Count) then
  begin
    SetCellByFieldName(DisplayedRowIndex, FColumnDefs[ColumnIndex].Field, Value);
  end
  else
  raise Exception.Create('Error: Invalid ColumnIndex provided.');
end;

procedure TDataGridBase.SetCells(DisplayedRowIndex: Integer; ColumnIndex: Integer;
  const Value: String);
begin
  SetCellByDisplayedRowIndex(DisplayedRowIndex, ColumnIndex, Value);
end;

procedure TDataGridBase.SetDisplayedRowSelected(DisplayedRowIndex: Integer;
  const Value: Boolean);
var
  RowNode: TJSRowNode;
begin
  if Assigned(FAGGrid) then
  begin
    RowNode := FAGGrid.getDisplayedRowAtIndex(DisplayedRowIndex);

    if _NotNullOrUndefined(RowNode) then
    begin
      RowNode.SetSelected(Value);
    end;
  end;
end;

procedure TDataGridBase.SetSuppressMoveWhenColumnDragging(const Value: Boolean);
begin
  FSuppressMoveWhenColumnDragging := Value;
  DoOptionsChange('suppressMoveWhenColumnDragging', FSuppressMoveWhenColumnDragging);
end;

function TDataGridBase.GetRowDataByFieldName(RowID: TJSValue; FieldName: String): TJSValue;
var
  RowNode: TJSRowNode;
begin
  Result := '';

  if Assigned(FAGGrid) then
  begin
    if Length(FieldName) > 0 then
    begin
      RowNode := FAGGrid.getRowNode(RowID);

      if _NotNullOrUndefined(RowNode) and
         _NotNullOrUndefined(RowNode.Data) then
      begin
        if _NotNullOrUndefined(RowNode.Data[FieldName]) then
          Result := String(Pointer(RowNode.Data[FieldName]))
        else
          raise Exception.Create('Error: Invalid FieldName provided.');
      end
      else
        raise Exception.Create('Error: Invalid RowID!');
    end
    else
      raise Exception.Create('Error: Invalid FieldName provided.');
  end;
end;

function TDataGridBase.GetRowDataById(RowID: TJSValue;
  ColumnIndex: Integer): TJSValue;
begin
  Result := '';

  if (ColumnIndex >= 0) and
     (ColumnIndex < FColumnDefs.Count) then
  begin
    Result := GetRowDataByFieldName(RowID, FColumnDefs[ColumnIndex].Field);
  end
  else
  raise Exception.Create('Error: Invalid ColumnIndex provided.');
end;

function TDataGridBase.GetAllCells(RowIndex: Integer; ColumnIndex: Integer): String;
var
  CellValue: TJSValue;
begin
  Result := '';
  CellValue := GetCellByIndex(RowIndex, ColumnIndex);
  if _NotNullOrUndefined(CellValue) then
    Result := String(CellValue);
end;

function TDataGridBase.GetAllFloats(RowIndex: Integer; ColumnIndex: Integer): Double;
var
  CellValue: TJSValue;
begin
  Result := 0;
  CellValue := GetCellByIndex(RowIndex, ColumnIndex);
  if _NotNullOrUndefined(CellValue) then
    Result := Double(CellValue);
end;

function TDataGridBase.GetCellByFieldName(DisplayedRowIndex: TJSValue;
  FieldName: String): TJSValue;
var
  RowNode: TJSRowNode;
begin
  Result := '';

  if Assigned(FAGGrid) then
  begin
    if Length(FieldName) > 0 then
    begin
      if _typeof(DisplayedRowIndex) <> 'number' then
          raise Exception.Create('Error: DisplayedRowIndex must be numeric.');

      RowNode := FAGGrid.getDisplayedRowAtIndex(Integer(DisplayedRowIndex));

      if _NotNullOrUndefined(RowNode) and
         _NotNullOrUndefined(RowNode.Data) then
      begin
        if _NotNullOrUndefined(RowNode.Data[FieldName]) then
          Result := String(Pointer(RowNode.Data[FieldName]))
        else
          raise Exception.Create('Error: Invalid FieldName provided.');
      end
      else
        raise Exception.Create('Error: Invalid DisplayedRowIndex!');
    end
    else
      raise Exception.Create('Error: Invalid FieldName provided.');
  end;
end;



procedure TDataGridBase.SetRowDataByFieldName(RowID: TJSValue; FieldName: String;
  const Value: TJSValue);
var
  RowNode: TJSRowNode;
begin
  if Assigned(FAGGrid) then
  begin
    if Length(FieldName) > 0 then
    begin
      // Check for valid FieldName
      if ColumnDefs.FindColumnIndex(FieldName) = -1 then
        raise Exception.Create('Error: Invalid FieldName!');

      RowNode := FAGGrid.getRowNode(RowID);

      if _NotNullOrUndefined(RowNode) and
         _NotNullOrUndefined(RowNode.Data) then
      begin

        RowNode.SetDataValue(FieldName, Value);
      end
      else
        raise Exception.Create('Error: Invalid RowID!');
    end
    else
      raise Exception.Create('Error: Invalid FieldName provided.');
  end;
end;

procedure TDataGridBase.SetRowDataById(RowID: TJSValue;
  ColumnIndex: Integer; const Value: TJSValue);
begin
  if (ColumnIndex >= 0) and
     (ColumnIndex < FColumnDefs.Count) then
  begin
    SetRowDataByFieldName(RowID, FColumnDefs[ColumnIndex].Field, Value);
  end
  else
  raise Exception.Create('Error: Invalid ColumnIndex provided.');
end;

procedure TDataGridBase.SetCellByFieldName(DisplayedRowIndex: TJSValue;
  FieldName: String; const Value: TJSValue);
var
  RowNode: TJSRowNode;
begin
  if Assigned(FAGGrid) then
  begin
    if Length(FieldName) > 0 then
    begin
      // Check for valid FieldName
      if ColumnDefs.FindColumnIndex(FieldName) = -1 then
        raise Exception.Create('Error: Invalid FieldName!');
      if _typeof(DisplayedRowIndex) <> 'number' then
        raise Exception.Create('Error: DisplayedRowIndex must be numeric.');

      RowNode := FAGGrid.getDisplayedRowAtIndex(Integer(DisplayedRowIndex));

      if _NotNullOrUndefined(RowNode) and
         _NotNullOrUndefined(RowNode.Data) then
      begin

        RowNode.SetDataValue(FieldName, Value);
      end
      else
        raise Exception.Create('Error: Invalid DisplayedRowIndex!');
    end
    else
      raise Exception.Create('Error: Invalid FieldName provided.');
  end;
end;

procedure TDataGridBase.SetEditType(const Value: TDGRowEditType);
begin
  if FEditType <> Value then
  begin
    FEditType := Value;
    case FEditType of
      retCell: DoOptionsChange('editType', nil);
      retFullRow: DoOptionsChange('editType', 'fullRow');
    end;
  end;
end;

procedure TDataGridBase.SetAllCells(RowIndex: Integer; ColumnIndex: Integer;
  const Value: String);
begin
  SetCellByIndex(RowIndex, ColumnIndex, Value);
end;

procedure TDataGridBase.SetAllFloats(RowIndex: Integer; ColumnIndex: Integer;
  const Value: Double);
begin
  SetCellByIndex(RowIndex, ColumnIndex, Value);
end;

procedure TDataGridBase.SetBidiMode(const Value: TBiDiMode);
begin
  if FBidiMode <> Value then
  begin
    case Value of
      bdLeftToRight:
        begin
          FBidiMode := Value;
          DoOptionsChange('enableRtl', False);
        end;
      bdRightToLeft:
        begin
          FBidiMode := Value;
          DoOptionsChange('enableRtl', True);
        end;
      bdRightToLeftNoAlign,
      bdRightToLeftReadingOnly:
        begin
          FBidiMode := bdRightToLeft;
          DoOptionsChange('enableRtl', True);
//          raise Exception.Create('Error: This BidiMode is not supported!');
        end;
    end;
  end;
end;

procedure TDataGridBase.SetMaxBlocksInCache(const Value: Integer);
begin
  FMaxBlocksInCache := Value;
  DoOptionsChange('maxBlocksInCache', FMaxBlocksInCache);
end;

procedure TDataGridBase.SetOnGetLocaleText(
  const Value: TDGGetLocaleTextCallBack);
begin
  if {$IFNDEF PAS2JS}@{$ENDIF}Value <> {$IFNDEF PAS2JS}@{$ENDIF}FOnGetLocaleText then
  begin
    FOnGetLocaleText := Value;
    if not (csLoading in ComponentState) then
    begin
      // Locale changes requires the re-creation of the grid
      RecreateGrid;
    end;
  end;
end;

procedure TDataGridBase.SetPagination(const Value: Boolean);
begin
  FPagination := Value;
  DoOptionsChange('pagination', FPagination);
end;

procedure TDataGridBase.SetPaginationAutoPageSize(const Value: Boolean);
begin
  FPaginationAutoPageSize := Value;
  DoOptionsChange('paginationAutoPageSize', FPaginationAutoPageSize);
end;

procedure TDataGridBase.SetPaginationPageSize(const Value: Integer);
begin
  FPaginationPageSize := Value;
  DoOptionsChange('paginationPageSize', FPaginationPageSize);
end;

procedure TDataGridBase.SetPaginationPageSizeSelector(const Value: String);
var
  NewValue, PrevValue, IntStr: String;
  StrArr: TArray<String>;
  IntArr: TJSArray;
  I, L, R: Integer;
begin
  if Value <> FPaginationPageSizeSelector then
  begin

    NewValue := TRegEx.Replace(Value, '[^0-9,]', '');
    StrArr := NewValue.Split([',']);

    TArrayHelper<String>.Sort(StrArr,
        TComparer<String>.Construct(
        function(const Left, Right: String): Integer
        begin
          Result := 0;
          if TryStrToInt(Left, L) and
             TryStrToInt(Right, R) then
          begin
            if L > R then
              Result := 1
            else if L < R then
              Result := -1;
          end;
        end
      )
    );
    PrevValue := '';
    NewValue := '';
    for I := Low(StrArr) to High(StrArr) do
    begin
      if TryStrToInt(StrArr[I], L) then
      begin
        IntStr := IntToStr(L);
        if PrevValue <> IntStr then
        begin
          if PrevValue = '0' then
            NewValue := '';
          if Length(NewValue) > 0 then
            NewValue := NewValue + ',';
          NewValue := NewValue + IntStr;
        end;
        PrevValue := IntStr;
      end;
    end;
    FPaginationPageSizeSelector := NewValue;
  end;
  if FPaginationPageSizeSelector = '0' then
    DoOptionsChange('paginationPageSizeSelector', False)
  else
  begin
    StrArr := FPaginationPageSizeSelector.Split([',']);
    IntArr := TJSArray._of;
    for I := Low(StrArr) to High(StrArr) do
    begin
      if TryStrToInt(StrArr[I], L) then
      begin
        IntArr.push(L);
      end;
    end;
    DoOptionsChange('paginationPageSizeSelector', IntArr);
  end;
end;

procedure TDataGridBase.SetRowData(const Value: TJSArray);
begin
  if Assigned(FAgGrid) and Assigned(Value) then
    FAGGrid.setGridOption('rowData', Value);
end;

procedure TDataGridBase.SetRowHeight(const Value: Integer);
begin
  if Assigned(FAgGrid) then
  begin
    if FRowHeight <> Value then
    begin
      FRowHeight := Value;
      if FRowHeight > 0 then
        DoOptionsChange('rowHeight', FRowHeight)
      else
        DoOptionsChange('rowHeight', nil);
    end;
  end;
end;

procedure TDataGridBase.SetRowMultiSelectWithClick(const Value: Boolean);
begin
  FRowMultiSelectWithClick := Value;
  DoOptionsChange('rowMultiSelectWithClick', FRowMultiSelectWithClick);
end;

procedure TDataGridBase.SetRowSelected(RowIndex: Integer; const Value: Boolean);
var
  RowNode: TJSRowNode;
begin
  if Assigned(FAGGrid) then
  begin
    if Assigned(ServerDataAdapter) then
      RowNode := FAGGrid.getRowNode(IntToStr(RowIndex))
    else
      RowNode := FAGGrid.getRowNode(RowIndex);

    if _NotNullOrUndefined(RowNode) then
    begin
      RowNode.SetSelected(Value);
    end;
  end;
end;

procedure TDataGridBase.SetRowSelection(const Value: TDGRowSelectionType);
begin
  if FRowSelection <> Value then
  begin
    FRowSelection := Value;
    case FRowSelection of
      rsSingle:
        DoOptionsChange('rowSelection', 'single');
      rsMultiple:
        DoOptionsChange('rowSelection', 'multiple');
    end;

  end;
end;

function TDataGridBase.SetSelectedRow(RowIndex: Integer;
  Selected: Boolean): Boolean;
var
  RowNode: TJSRowNode;
begin
  Result := False;
  if Assigned(FAGGrid) then
  begin
    // Get the row node again since we have updated it above
    if Assigned(ServerDataAdapter) then
      RowNode := FAGGrid.getRowNode(IntToStr(RowIndex))
    else
      RowNode := FAGGrid.getRowNode(RowIndex);

    if _NotNullOrUndefined(RowNode) then
    begin
      // Reselect the row
      RowNode.SetSelected(Selected);

      Result := True;
    end;
  end;
end;

procedure TDataGridBase.SetServerDataAdapter(const Value: TDGServerDataAdapter);
begin
  if Value <> FServerDataAdapter then
  begin
    if FServerDataAdapter <> nil then
    begin
      FServerDataAdapter.UnregisterPaginationChangeHandler({$IFDEF PAS2JS}@{$ENDIF}HandleDSPaginationChanged);
      FServerDataAdapter.UnregisterDataChangeHandler({$IFDEF PAS2JS}@{$ENDIF}HandleDSDataChanged);

      FServerDataAdapter.RemoveFreeNotification(Self);
    end;

    FServerDataAdapter := Value;

    if Value <> nil then
    begin
      Value.FreeNotification(Self);

      FServerDataAdapter.RegisterPaginationChangeHandler({$IFDEF PAS2JS}@{$ENDIF}HandleDSPaginationChanged);
      FServerDataAdapter.RegisterDataChangeHandler({$IFDEF PAS2JS}@{$ENDIF}HandleDSDataChanged);
    end;
  end;
end;


procedure TDataGridBase.SetEnableClickSelection(const Value: Boolean);
begin
  FEnableClickSelection := Value;
  DoOptionsChange('suppressRowClickSelection', not FEnableClickSelection);
  DoOptionsChange('suppressRowDeselection', not FEnableClickSelection);
  DoOptionsChange('enableClickSelection', FEnableClickSelection);
end;

procedure TDataGridBase.SetFilterModel(const Value: TJSValue);
begin
  if Assigned(FAGGrid) then
  begin
    FAGGrid.setFilterModel(Value);
  end;
end;

procedure TDataGridBase.SetFloats(DisplayedRowIndex: Integer; ColumnIndex: Integer;
  const Value: Double);
begin
  SetCellByDisplayedRowIndex(DisplayedRowIndex, ColumnIndex, Value);
end;

procedure TDataGridBase.SetLocale(const Value: TDGLocale);
begin
  if Value <> FLocale then
  begin
    FLocale := Value;
    if not (csLoading in ComponentState) then
    begin
      // Locale changes requires the re-creation of the grid
      RecreateGrid;
    end;
  end;
end;

procedure TDataGridBase.AddColumn(Item: TDGCollectionItem;
  Arr: TJSArray);
var
  ColumnDef: TDGColumnDefsCollectionItem;
begin
  ColumnDef := Item as TDGColumnDefsCollectionItem;
  if Assigned(ColumnDef) then
  begin
    Arr.push(ColumnDef.GetAsJSObject);
  end;
end;

function TDataGridBase.AddRootHeaderObject(ToArr: TJSArray; RootHeader: TJSObject): Boolean;
var
  I: Integer;
  Found: Boolean;
begin
  Result := False;
  if TJSArray.isArray(ToArr) and
     _NotNullOrUndefined(RootHeader) then
  begin
    Found := False;
    for I := 0 to ToArr.Length - 1 do
    begin
      if ToArr[I] = RootHeader then
      begin
        Found := True;
      end;
    end;

    if Found then
      Result := True
    else
      ToArr.push(RootHeader);
  end;
end;

procedure TDataGridBase.OnColumnDefsChanged(Sender: TObject);
var
  Arr: TJSArray;
  I: Integer;
  Collection: TDGColumnDefsCollection;
  Handled: Boolean;
  Children, Columns: TJSArray;
  Found, ReorderNeeded: Boolean;
  PathName: String;
  HeaderItem, CurrentHeaderItem, PrevHeaderItem, LastRootHeader: TDGMultilevelHeaderCollectionItem;
  NewTemp: TJSObject;
  J: Integer;
begin

  if (csLoading in ComponentState) then
    Exit;

  Collection := TDGUtils.AsType<TDGColumnDefsCollection>(Sender);
  if Assigned(Collection) then
  begin
    ReorderNeeded := False;
    //AC: Clear existing associated column defs
    MultilevelHeaders.Traverse(function (Param: TDGMultilevelHeaderParams): Boolean
      begin
        Result := False;
        if Assigned(Param.Item) and
           Assigned(Param.Item.InternalJSObject) then
        begin
          {$IFNDEF PAS2JS}Param.Item.InternalJSObject.Free;{$ENDIF}
          Param.Item.InternalJSObject := nil;
        end;
      end);
    LastRootHeader := nil;
    Arr := TJSArray._of;
    for I := 0 to Collection.Count - 1 do
    begin
      PathName := Collection.Items[I].ParentHeader;
      if PathName <> '' then
      begin
        HeaderItem := MultilevelHeaders.GetPathItem(PathName);
        if Assigned(HeaderItem) then
        begin
          //AC: Find root header
          CurrentHeaderItem := HeaderItem;
          PrevHeaderItem := nil;
          while True do
          begin
            if not _NotNullOrUndefined(CurrentHeaderItem.InternalJSObject) then
            begin
              CurrentHeaderItem.InternalJSObject :=
                new(['headerName', CurrentHeaderItem.HeaderName,
                     'children', TJSArray._of]);
            
            end;
            
            if _NotNullOrUndefined(CurrentHeaderItem.InternalJSObject) and
               TJSArray.isArray(CurrentHeaderItem.InternalJSObject['children']) then
            begin
              Children := TJSArray(Pointer(CurrentHeaderItem.InternalJSObject['children']));
              if (CurrentHeaderItem = HeaderItem) then
              begin
                Children.push(Collection.Items[I].GetAsJSObject);
              end
              else
              begin
                if _NotNullOrUndefined(PrevHeaderItem) and
                   _NotNullOrUndefined(PrevHeaderItem.InternalJSObject) then
                begin
                  //AC: Add header item if not already added
                  Found := False;
                  for J := 0 to Children.Length - 1 do
                  begin
                    if Children[J] = PrevHeaderItem.InternalJSObject then
                    begin
                      Found := True;
                      break;
                    end;
                  end;
                  if not Found then
                    Children.push(PrevHeaderItem.InternalJSObject);
                end;
              end;
            end;

            if CurrentHeaderItem.Parent = nil then
              raise Exception.Create('Error: CurrentHeaderItem does not have a Parent!');
            if CurrentHeaderItem.Parent.ParentItem = nil then
              break;

            PrevHeaderItem := CurrentHeaderItem;
            CurrentHeaderItem := CurrentHeaderItem.Parent.ParentItem;
          end;

          if (LastRootHeader <> nil) and
             (LastRootHeader <> CurrentHeaderItem) then
          begin
            if AddRootHeaderObject(Arr, LastRootHeader.InternalJSObject) then
              ReorderNeeded := True;
          end;
          LastRootHeader := CurrentHeaderItem;
        end;
      end
      else
      begin
        if LastRootHeader <> nil then
        begin
          if AddRootHeaderObject(Arr, LastRootHeader.InternalJSObject) then
            ReorderNeeded := True;
          LastRootHeader := nil;
        end;

        Arr.push(Collection.Items[I].GetAsJSObject);
      end;
    end;

    if LastRootHeader <> nil then
    begin
      if AddRootHeaderObject(Arr, LastRootHeader.InternalJSObject) then
        ReorderNeeded := True;
{$IFDEF PAS2JS}
      LastRootHeader := nil;
{$ENDIF}
    end;

    Handled := False;
    OnBeforeColumnDefsUpdate(Arr, Handled);
    if not Handled then
    begin
      if Assigned(FAgGrid) then
      begin
        if ReorderNeeded then
          FAgGrid.setGridOption('suppressColumnMoveAnimation', True);

        FAgGrid.setGridOption('columnDefs', Arr);

        if ReorderNeeded then
        begin
          Columns := TJSArray._of;
          for I := 0 to ColumnDefs.Count - 1 do
          begin
            NewTemp := new(['colId', ColumnDefs.Items[I].Field]);
            Columns.push(NewTemp);
          end;
          FAgGrid.applyColumnState(TJSApplyColumnStateParams(Pointer(new([
            'state', Columns,
            'applyOrder', True
          ]))));
          FAgGrid.setGridOption('suppressColumnMoveAnimation', False);
        end;
      end;
    end;
  end;
end;

{$IFDEF DESIGNER}
function TDataGridBase.ColumnDefsCount: Integer;
begin
  Result := ColumnDefs.Count;
end;

procedure TDataGridBase.ColWidthsChanged;
var
  c: integer;
begin
  if FColWidthUpdating then
    Exit;
  inherited;
  try
    FColWidthUpdating := True;
    if Assigned(FColumnDefs) then
    begin
      for c := 0 to FColumnDefs.Count - 1 do
      begin
        if c + FixedCols < ColCount then
        begin
          if ColWidths[c + FixedCols] <> DefaultColWidth then
            FColumnDefs[c].Width := ColWidths[c + FixedCols];
        end;
      end;
    end;
  finally
    FColWidthUpdating := False;
  end;
end;

function TDataGridBase.__ConvertName(Value: String): String;
var
  I,O: Integer;
  c: Char;
begin
  Result := '';
  if Value <> '' then
  begin
    for I := 1 to Length(Value) do
    begin
      C := Value[I];
      O := Ord(C);
      if I = 1 then
      begin
        if (O >= 97) and (O <= 122) then
        begin
          // Small caps convert to capital
          C := Chr(O - 32);
        end;
      end
      else
      begin
        if (O >= 65) and (O <= 90) then
        begin
          // Capital letter inserts a space
        Result := Result + ' ';
        end;
      end;
      Result := Result + C;
    end;
  end;
end;
procedure TDataGridBase._UpdateColumnDefs(Sender: TObject);
var
  I, C, NewColCount: Integer;
  Item: TDGColumnDefsCollectionItemBase;
  DisplayName: String;
  HeaderDepth, MaxDepth, Depth: Integer;
  HeaderItem, PrevHeaderItem, CurrentHeader, CurrentAdjacentHeader: TDGMultilevelHeaderCollectionItem;
  J, K, X: Integer;
begin
  if FColWidthUpdating then
    Exit;
  try
    FColWidthUpdating := True;

    PrevHeaderItem := nil;
    MaxDepth := 0;
    for I := 0 to FColumnDefs.Count - 1 do
    begin
      Item := FColumnDefs.Items[I];
      if Item.ParentHeader <> '' then
      begin
        Depth := MultilevelHeaders.GetPathDepth(Item.ParentHeader);
        if MaxDepth < Depth then
          MaxDepth := Depth;
      end;
    end;
    HeaderDepth := MaxDepth + 1;
    if (HeaderDepth >= RowCount) then
      RowCount := HeaderDepth + 1;
    FixedRows := HeaderDepth;
//AC: ShowMessage('FixedRows = '+IntToStr(FixedRows));

    NewColCount := FColumnDefs.Count + FixedCols;
    ColCount := NewColCount;
    if NewColCount > 0 then
    begin
      ColWidths[0] := DefaultColWidth;  //AC: We can't use ColWidths or else it will be stored in the DFM and causes an error.
      for I := 0 to FColumnDefs.Count - 1 do
      begin
        C := I + FixedCols;
        if (RowCount > 0) and (C < Length(FDesignerGridData[0])) then
        begin
          Item := FColumnDefs.Items[I];
          DisplayName := __ConvertName(Item.Field);
          if Item.HeaderName <> '' then
          begin
            DisplayName := Item.HeaderName;
          end;
          FDesignerGridData[0][C] := DisplayName;

          Depth := 0;
          if Item.ParentHeader <> '' then
          begin
            Depth := MultilevelHeaders.GetPathDepth(Item.ParentHeader);
            HeaderItem := MultilevelHeaders.GetPathItem(Item.ParentHeader);
          end
          else
          begin
            HeaderItem := nil;
          end;

          //AC: Init all the FDesignerGridData one row at a time
          for J := 0 to MaxDepth do
          begin
            //AC: Set the default FDesignerGridData cell to empty
            FDesignerGridData[J][C] := '';
            FDesignerGridMergeLeft[J][C] :=  False;
            FDesignerGridMergeBottom[J][C] :=  False;

            if J < Depth then
            begin
              //AC: Parent header cell
              if Assigned(HeaderItem) then
              begin
                CurrentHeader := HeaderItem;
                //AC: Look for the current header
                X := Depth - (J + 1);
                for K := 0 to X - 1 do
                begin
                  if (CurrentHeader.Parent <> nil) and
                     (CurrentHeader.Parent.ParentItem <> nil) then
                  begin
                    CurrentHeader := CurrentHeader.Parent.ParentItem;
                  end;
                end;

                //AC: See if the CurrentHeader match any adjacent headers
                CurrentAdjacentHeader := PrevHeaderItem;
                while CurrentAdjacentHeader <> nil do
                begin
                  if CurrentHeader = CurrentAdjacentHeader then
                  begin
                    //AC: CurrentHedaer matches an adjacent header, so
                    //AC: we don't need to display anything...
                    CurrentHeader := nil;
                    FDesignerGridMergeLeft[J][C] := True;
                    break;
                  end;

                  if (CurrentAdjacentHeader.Parent <> nil) and
                     (CurrentAdjacentHeader.Parent.ParentItem <> nil) then
                  begin
                    CurrentAdjacentHeader := CurrentAdjacentHeader.Parent.ParentItem;
                  end
                  else
                    CurrentAdjacentHeader := nil;
                end;

                if CurrentHeader <> nil then
                  FDesignerGridData[J][C] := CurrentHeader.HeaderName;
              end;
            end
            else if J = MaxDepth then
              //AC: Actual column
              FDesignerGridData[J][C] := DisplayName
            else
              FDesignerGridMergeBottom[J][C] := True;

          end;

          PrevHeaderItem := HeaderItem;

          if not Assigned(Item.OnChange) then
          begin
            Item.OnChange := _OnColumnDefsItemChanged;
          end;

          // Update designer column widths
          if Item.Width > 0 then
          begin
              ColWidths[C] := Item.Width;
          end;
        end;
      end;
    end
    else
    begin
      ColWidths[0] := 0;

    end;
    Repaint;
  finally
    FColWidthUpdating := False;
  end;
end;
procedure TDataGridBase._OnColumnDefsChanged(Sender: TObject);
begin
  _UpdateColumnDefs(Sender);
end;
procedure TDataGridBase._OnColumnDefsItemChanged(Sender: TObject);
begin
  _UpdateColumnDefs(Sender);
end;
{$ENDIF}


function TDataGridBase.FindFirstChildElement(TagName: String;
  CurrentElement: TJSHTMLElement): TJSHTMLElement;
var
  Count, I: Integer;
  ChildElement: TJSHTMLElement;
  UTagName: String;
begin
  Result := nil;
  UTagName := UpperCase(TagName);
  Count := CurrentElement.childElementCount;
  for I := 0 to Count - 1 do
  begin
    ChildElement := TJSHTMLElement(CurrentElement.children.item(I));
    if _NotNullOrUndefined(ChildElement.tagName) and
       (UpperCase(ChildElement.tagName) = UTagName) then
    begin
      Result := ChildElement;
      break;
    end;
  end;

end;

function TDataGridBase.FindFirstSelectedRowNode: TJSRowNode;
var
  SelectedNodes: TJSRowNodes;
  RowNode: TJSRowNode;
begin
  Result := nil;
  if Assigned(FAGGrid) then
  begin
    // Get the selected row nodes
    SelectedNodes := FAGGrid.getSelectedNodes;
    if Length(SelectedNodes) > 0 then
    begin
      // Get the first row selected
      RowNode := SelectedNodes[0];

      if _NotNullOrUndefined(RowNode) then
        Result := RowNode;
    end;
  end;
end;

function TDataGridBase.FindFirstSelectedDisplayedRowIndex: Integer;
var
  RowNode: TJSRowNode;
begin
  Result := -1;
  RowNode := FindFirstSelectedRowNode;
  if RowNode <> nil then
    Result := RowNode.RowIndex;
end;

function TDataGridBase.FindFirstSelectedRowIndex: Integer;
var
  RowNode: TJSRowNode;
begin
  Result := -1;
  RowNode := FindFirstSelectedRowNode;
  if (RowNode <> nil) then
  begin
    Result := _parseIntValue(RowNode.Id);
    if _isNaN(Result) then
      Result := -1;
  end;
end;

function TDataGridBase.FindFirstSelectedRowId: String;
var
  RowNode: TJSRowNode;
begin
  Result := '';
  RowNode := FindFirstSelectedRowNode;
  if RowNode <> nil then
    Result := RowNode.Id;
end;

{$ENDREGION}
{$ENDREGION}

{$REGION 'Utility Methods'}
{$IFNDEF DESIGNER}
function TDataGridBase.GetJsonProperties(IncludeUrl: Boolean = true) : TJSObject;
var
  Props: TJSPropertySerializer;
begin
  try
    Props := TJSPropertySerializer.Create;
    FillProperties(Props, IncludeUrl);
    Result := Props.AsJsObject(False);
  finally
    FreeAndNil(Props);
  end;
end;
{$ENDIF}

function TDataGridBase.GetFilterModel: TJSValue;
begin
  Result := nil;
  if Assigned(FAGGrid) then
    Result := FAGGrid.getFilterModel();
end;

function TDataGridBase.GetFloats(DisplayedRowIndex: Integer;
  ColumnIndex: Integer): Double;
var
  CellValue: TJSValue;
begin
  Result := 0;
  CellValue := GetCellByDisplayedRowIndex(DisplayedRowIndex, ColumnIndex);
  if _NotNullOrUndefined(CellValue) then
    Result := Double(CellValue);
end;

{$IFNDEF DESIGNER}
function TDataGridBase.GetGridOptions: TJSObject;
var
  PS: TJSPropertySerializer;
begin
  PS := TJSPropertySerializer.Create;
  FillProperties(PS, True);
  Result := PS.AsJsObject(True);
end;

procedure TDataGridBase.FillProperties(Props: TJSPropertySerializer; IncludeUrl: Boolean = true);
begin
  if Assigned(ServerDataAdapter) then
  begin
    FMaxBlocksInCache := 1;
    if FPagination then
    begin
      FCacheBlockSize := FPaginationPageSize;
    end;
  end;

  Props.AddCollectionAsArray<TDGCollectionItem>('columnDefs', FColumnDefs, {$IFDEF PAS2JS}@{$ENDIF}AddColumn);
  if FDefaultColDef.Enabled then
    Props.Add('defaultColDef', FDefaultColDef.GetAsJSObject, nil);
  Props.Add('pagination', FPagination, False);
  Props.Add('paginationAutoPageSize', FPaginationAutoPageSize, True);
  Props.Add('paginationPageSize', FPaginationPageSize, 0);
  Props.Add('cacheBlockSize', FCacheBlockSize, 100);
  Props.Add('maxBlocksInCache', FMaxBlocksInCache, 0);
  Props.AddType<TBiDiMode>('enableRtl', FBidiMode, function(Value: TBiDiMode): TJSValue
  begin
    Result := nil;
    case FBidiMode of
      bdLeftToRight: Result := False;
      bdRightToLeft: Result := True;
      bdRightToLeftNoAlign: Result := True;
      bdRightToLeftReadingOnly: Result := True;
    end;
  end);
  Props.Add('suppressMoveWhenColumnDragging', FSuppressMoveWhenColumnDragging, False);
  if FPaginationPageSizeSelector = '0' then
    Props.Add('paginationPageSizeSelector', False, True)
  else
  begin
    Props.AddType<String>('paginationPageSizeSelector', FPaginationPageSizeSelector, function(Value: String): TJSValue
    var
      Arr: TJSArray;
      StrArr: TArray<String>;
      I,PageSize: Integer;
    begin
      Result := nil;
      if Value <> '' then
      begin
        StrArr := Value.Split([',']);
        Arr := TJSArray._of;
        for I := Low(StrArr) to High(StrArr) do
        begin
          if TryStrToInt(StrArr[I], PageSize) then
            Arr.push(PageSize);
        end;
        Result := Arr;
      end;
    end);
  end;
  Props.AddType<TDGRowSelectionType>('rowSelection', FRowSelection, function(Value: TDGRowSelectionType): TJSValue
  begin
    Result := nil;
    case Value of
      rsSingle: Result := 'single';
      rsMultiple: Result := 'multiple';
    end;
  end);
  Props.Add('rowMultiSelectWithClick', FRowMultiSelectWithClick, False);

  Props.Add('suppressRowDeselection', not FEnableClickSelection, False);
  Props.Add('suppressRowClickSelection', not FEnableClickSelection, False);
  Props.Add('enableClickSelection', FEnableClickSelection, True);
  Props.AddType<TDGRowEditType>('editType', FEditType, function(Value: TDGRowEditType): TJSValue
  begin
    Result := nil;
    case Value of
      retCell: Result := 'single';
      retFullRow: Result := 'fullRow';
    end;
  end);
  Props.AddType<TDGServerDataAdapter>('datasource', FServerDataAdapter, function(ServerDS: TDGServerDataAdapter): TJSValue
  var
    DataSource: TJSDataSource;
  begin
    Result := nil;
    if Assigned(ServerDS) then
    begin
{$IFDEF OBSOLETE}
      ServerDS.AGGrid := FAGGrid;
{$ENDIF}

      DataSource := TJSDataSource.Create;
      DataSource.GetRows := {$IFDEF PAS2JS}@{$ENDIF}ServerDS.HandleGetRows;
      Result := DataSource;
    end;
  end);
  Props.AddType<TDGServerDataAdapter>('rowModelType', FServerDataAdapter, function(ServerDS: TDGServerDataAdapter): TJSValue
  begin
    Result := 'clientSide';
    if Assigned(ServerDS) then
    begin
      Result := 'infinite';
    end;
  end);

  if csDesigning in ComponentState then
    Props.Add('suppressNoRowsOverlay', True, False);

  Props.Add('rowHeight', FRowHeight, 0);
  Props.Add('localeText', GetLocaleText, nil);

  FillEvents(Props, IncludeUrl);

end;

procedure TDataGridBase.FillEvents(Props: TJSPropertySerializer; IncludeUrl: Boolean = True);
var
  AOnRowSelected: TDGRowSelectedCallBack;
  AOnCellValueChanged: TDGCellEditingEvent;
  AOnCellEditingStarted: TDGCellEditingEvent;
  AOnCellEditingStopped: TDGCellEditingEvent;
  AOnRowEditingStarted: TDGRowEditingEvent;
  AOnRowEditingStopped: TDGRowEditingEvent;
  ATabToNextCell: TDGTabToNextCellEvent;
  AOnPaginationChanged: TDGPaginationChangedEvent;
  AOnSelectionChanged: TDGSelectionChangedEvent;
  AOnSortChanged: TDGSortChangedEvent;
  AOnFilterChanged: TDGFilterChangedEvent;
  AOnGetLocaleText: TDGGetLocaleTextCallBack;

  AOnGetRowStyle: TDGGetRowStyleCallback;
  AOnGetRowClass: TDGGetRowClassCallback;
  AOnGetRowHeight: TDGGetRowHeightCallback;
  AOnCellMouseDown: TDGCellMouseDown;
  AOnCellFocusedEvent: TDGCellFocusedEvent;
  AOnCellMouseOverEvent: TDGCellMouseOverEvent;
  AOnCellClickedEvent: TDGCellClickedEvent;
  AOnCellDoubleClickedEvent: TDGCellDoubleClickedEvent;

begin
  AOnRowSelected := HandleOnRowSelectedEvent;
  AOnCellValueChanged := HandleOnCellValueChanged;
  AOnCellEditingStarted := HandleOnCellEditingStarted;
  AOnCellEditingStopped := HandleOnCellEditingStopped;
  AOnRowEditingStarted := HandleOnRowEditingStarted;
  AOnRowEditingStopped := HandleOnRowEditingStopped;
  ATabToNextCell := HandleTabToNextCell;
  AOnPaginationChanged := HandleOnPaginationChanged;
  AOnSelectionChanged := HandleOnSelectionChanged;
  AOnSortChanged := HandleOnSortChanged;
  AOnFilterChanged := HandleOnFilterChanged;
  AOnGetLocaleText := HandleOnGetLocaleText;
  AOnGetRowStyle := HandleOnGetRowStyleCallback;
  AOnGetRowClass := HandleOnGetRowClassCallback;
  AOnGetRowHeight := HandleOnGetRowHeightCallback;
  AOnCellMouseDown := HandleOnCellMouseDown;
  AOnCellFocusedEvent := HandleOnCellFocusedEvent;
  AOnCellMouseOverEvent := HandleOnCellMouseOverEvent;
  AOnCellClickedEvent := HandleOnCellClickedEvent;
  AOnCellDoubleClickedEvent := HandleOnCellDoubleClickedEvent;

  Props.Add('onRowSelected', {$IFNDEF PAS2JS}@{$ENDIF}AOnRowSelected, 'AOnRowSelected');
  Props.Add('onCellValueChanged', {$IFNDEF PAS2JS}@{$ENDIF}AOnCellValueChanged, 'AOnCellValueChanged');
  Props.Add('onCellEditingStarted', {$IFNDEF PAS2JS}@{$ENDIF}AOnCellEditingStarted, 'AOnCellEditingStarted');
  Props.Add('onCellEditingStopped', {$IFNDEF PAS2JS}@{$ENDIF}AOnCellEditingStopped, 'AOnCellEditingStopped');
  Props.Add('onRowEditingStarted', {$IFNDEF PAS2JS}@{$ENDIF}AOnRowEditingStarted, 'AOnRowEditingStarted');
  Props.Add('onRowEditingStopped', {$IFNDEF PAS2JS}@{$ENDIF}AOnRowEditingStopped, 'AOnRowEditingStopped');
  Props.Add('tabToNextCell', {$IFNDEF PAS2JS}@{$ENDIF}ATabToNextCell, 'ATabToNextCell');
  Props.Add('onPaginationChanged', {$IFNDEF PAS2JS}@{$ENDIF}AOnPaginationChanged, 'AOnPaginationChanged');
  Props.Add('onSelectionChanged', {$IFNDEF PAS2JS}@{$ENDIF}AOnSelectionChanged, 'AOnSelectionChanged');
  Props.Add('onSortChanged', {$IFNDEF PAS2JS}@{$ENDIF}AOnSortChanged, 'AOnSortChanged');
  Props.Add('onFilterChanged', {$IFNDEF PAS2JS}@{$ENDIF}AOnFilterChanged, 'AOnFilterChanged');

  Props.Add('getRowStyle', {$IFNDEF PAS2JS}@{$ENDIF}AOnGetRowStyle, 'FOnGetRowStyle');
  Props.Add('getRowClass', {$IFNDEF PAS2JS}@{$ENDIF}AOnGetRowClass, 'FOnGetRowClass');
  Props.Add('getRowHeight', {$IFNDEF PAS2JS}@{$ENDIF}AOnGetRowHeight, 'FOnGetRowClass');

  if Assigned(FOnGetLocaleText) then  // getLocaleText overrides localeText so it should not be used if the event is not assigned
    Props.Add('getLocaleText', {$IFNDEF PAS2JS}@{$ENDIF}AOnGetLocaleText, 'AOnGetLocaleText');

  Props.Add('onCellMouseDown', {$IFNDEF PAS2JS}@{$ENDIF}AOnCellMouseDown, 'FOnCellMouseDown');
  Props.Add('onCellFocused', {$IFNDEF PAS2JS}@{$ENDIF}AOnCellFocusedEvent, 'FOnCellFocusedEvent');
  Props.Add('onCellMouseOver', {$IFNDEF PAS2JS}@{$ENDIF}AOnCellMouseOverEvent, 'FOnCellMouseOverEvent');
  Props.Add('onCellClicked', {$IFNDEF PAS2JS}@{$ENDIF}AOnCellClickedEvent, 'FOnCellClickedEvent');
  Props.Add('onCellDoubleClicked', {$IFNDEF PAS2JS}@{$ENDIF}AOnCellDoubleClickedEvent, 'FOnCellDoubleClickedEvent');

end;

function TDataGridBase.GetFullName(Component: TComponent): String;
var
  OwnerName: String;
begin
  Result := '';
  if Component <> nil then
  begin
    OwnerName := GetFullName(Component.Owner);
    if OwnerName <> '' then
    begin
      Result := Result + OwnerName + '.';
    end
    else
    begin
      // Get the component's module name
      asm
        {
          if (typeof(Component.$module) != 'undefined' && typeof(Component.$module.$name) != 'undefined')
            Result = Result + 'pas.' + Component.$module.$name + '.';
        }
      end;
    end;
    Result := Result + Component.Name;
  end;
end;

function TDataGridBase.GetJsonPropertiesString(IncludeUrl: Boolean = true) : String;
{$IFNDEF DESIGNER}
var
  Props: TJSPropertySerializer;
  Prefix: String;
{$ENDIF}
begin
  Result := '';
{$IFNDEF DESIGNER}
  try
    Props := TJSPropertySerializer.Create;
    FillProperties(Props, IncludeUrl);
    Prefix := GetFullName(Self);
    Result := Props.AsJsonString(True, Prefix);
  finally
    FreeAndNil(Props);
  end;
{$ENDIF}
end;

function TDataGridBase.GetLocaleText: TJSObject;
begin
  Result := nil;
  case FLocale of
    localeNone: Result := nil;
    localeBG: Result := FAGGridLocale.AG_GRID_LOCALE_BG;
    localeBR: Result := FAGGridLocale.AG_GRID_LOCALE_BR;
    localeCN: Result := FAGGridLocale.AG_GRID_LOCALE_CN;
    localeCZ: Result := FAGGridLocale.AG_GRID_LOCALE_CZ;
    localeDE: Result := FAGGridLocale.AG_GRID_LOCALE_DE;
    localeDK: Result := FAGGridLocale.AG_GRID_LOCALE_DK;
    localeEG: Result := FAGGridLocale.AG_GRID_LOCALE_EG;
    localeEN: Result := FAGGridLocale.AG_GRID_LOCALE_EN;
    localeES: Result := FAGGridLocale.AG_GRID_LOCALE_ES;
    localeFI: Result := FAGGridLocale.AG_GRID_LOCALE_FI;
    localeFR: Result := FAGGridLocale.AG_GRID_LOCALE_FR;
    localeGR: Result := FAGGridLocale.AG_GRID_LOCALE_GR;
    localeHK: Result := FAGGridLocale.AG_GRID_LOCALE_HK;
    localeHR: Result := FAGGridLocale.AG_GRID_LOCALE_HR;
    localeHU: Result := FAGGridLocale.AG_GRID_LOCALE_HU;
    localeIL: Result := FAGGridLocale.AG_GRID_LOCALE_IL;
    localeIR: Result := FAGGridLocale.AG_GRID_LOCALE_IR;
    localeIT: Result := FAGGridLocale.AG_GRID_LOCALE_IT;
    localeJP: Result := FAGGridLocale.AG_GRID_LOCALE_JP;
    localeKR: Result := FAGGridLocale.AG_GRID_LOCALE_KR;
    localeNL: Result := FAGGridLocale.AG_GRID_LOCALE_NL;
    localeNO: Result := FAGGridLocale.AG_GRID_LOCALE_NO;
    localePK: Result := FAGGridLocale.AG_GRID_LOCALE_PK;
    localePL: Result := FAGGridLocale.AG_GRID_LOCALE_PL;
    localePT: Result := FAGGridLocale.AG_GRID_LOCALE_PT;
    localeRO: Result := FAGGridLocale.AG_GRID_LOCALE_RO;
    localeSE: Result := FAGGridLocale.AG_GRID_LOCALE_SE;
    localeSK: Result := FAGGridLocale.AG_GRID_LOCALE_SK;
    localeTR: Result := FAGGridLocale.AG_GRID_LOCALE_TR;
    localeTW: Result := FAGGridLocale.AG_GRID_LOCALE_TW;
    localeUA: Result := FAGGridLocale.AG_GRID_LOCALE_UA;
    localeVN: Result := FAGGridLocale.AG_GRID_LOCALE_VN;
  end;
end;

function TDataGridBase.GetRowCount: Integer;
begin
  Result := -1;
  if Assigned(FAgGrid) then

    Result := FAGGrid.getDisplayedRowCount;
end;
{$ENDIF DESIGNER}

function TDataGridBase.GetRowData: TJSArray;
begin
  Result := nil;
  if Assigned(FAgGrid) then
  begin
    Result := TJSArray(Pointer(FAGGrid.getGridOption('rowData')));
  end;
end;

function TDataGridBase.GetRowSelected(RowIndex: Integer): Boolean;
var
  RowNode: TJSRowNode;
begin
  Result := False;
  if Assigned(FAGGrid) then
  begin
    if Assigned(ServerDataAdapter) then
      RowNode := FAGGrid.getRowNode(IntToStr(RowIndex))
    else
      RowNode := FAGGrid.getRowNode(RowIndex);

    if _NotNullOrUndefined(RowNode) then
    begin
      Result := RowNode.isSelected;
    end;
  end;
end;

procedure TDataGridBase.HandleOnCellClickedEvent(Event: TJSCellClickedEvent);
begin
  if Assigned(FOnCellClickedEvent) then
    FOnCellClickedEvent(Event);
end;

procedure TDataGridBase.HandleOnCellDoubleClickedEvent(
  Event: TJSCellDoubleClickedEvent);
begin
  if Assigned(FOnCellDoubleClickedEvent) then
    FOnCellDoubleClickedEvent(Event);
end;

procedure TDataGridBase.HandleOnCellEditingStarted(Params: TJSCellEditingEvent);
begin
  if Assigned(FOnCellEditingStarted) then
    FOnCellEditingStarted(Params);
end;

procedure TDataGridBase.HandleOnCellEditingStopped(Params: TJSCellEditingEvent);
begin
  if Assigned(FOnCellEditingEnded) then
    FOnCellEditingEnded(Params);

  if (FEditType = retCell) and
     Assigned(FServerDataAdapter) and
     Assigned(Params.Data) then
  begin
    if _typeof(Params.NewValue) = 'undefined' then
    begin
      // End of an insert operation
      // Not used at the moment but can be used to create an event

    end
    else if Params.OldValue <> Params.NewValue then
    begin
      TDGServerDataAdapterInternal(FServerDataAdapter).UpdateRow(Self, Params.Data, procedure(RowData: TJSObject)
      begin
        if Assigned(FAGGrid) then
          FAGGrid.refreshInfiniteCache;
      end);
    end;
  end;
end;

procedure TDataGridBase.HandleOnCellFocusedEvent(Event: TJSCellFocusedEvent);
begin
  if Assigned(FOnCellFocusedEvent) then
    FOnCellFocusedEvent(Event);
end;

procedure TDataGridBase.HandleOnCellMouseDown(Event: TJSCellMouseDownEvent);
begin
  if Assigned(FOnCellMouseDown) then
    FOnCellMouseDown(Event);
end;

procedure TDataGridBase.HandleOnCellMouseOverEvent(
  Event: TJSCellMouseDownEvent);
begin
  if Assigned(FOnCellMouseOverEvent) then
    FOnCellMouseOverEvent(Event);
end;

procedure TDataGridBase.HandleOnCellValueChanged(Params: TJSCellEditingEvent);

begin

  if Assigned(FOnCellValueChanged) then
    FOnCellValueChanged(Params);
end;

procedure TDataGridBase.HandleOnFilterChanged(Event: TJSFilterChangedEvent);
begin
  if Assigned(FOnFilterChanged) then
    FOnFilterChanged(Event);
end;

function TDataGridBase.HandleOnGetLocaleText(
  Params: TJSGetLocaleTextParams): string;
begin
  if (_typeof(Params) = 'object') and
     (_typeof(Params.defaultValue) = 'string') then
    Result := Params.defaultValue;
  if Assigned(FOnGetLocaleText) then
    Result := FOnGetLocaleText(Params);
end;

function TDataGridBase.HandleOnGetRowClassCallback(
  Params: TJSGetRowClassParams): TJSValue;
begin
  Result := nil;
  if Assigned(FOnGetRowClass) then
    Result := FOnGetRowClass(Params);
end;

function TDataGridBase.HandleOnGetRowHeightCallback(
  Params: TJSRowHeightParams): TJSObject;
begin
  Result := nil;
  if Assigned(FOnGetRowHeight) then
    Result := FOnGetRowHeight(Params);
end;

function TDataGridBase.HandleOnGetRowStyleCallback(
  Params: TJSGetRowStyleParams): TJSObject;
begin
  Result := nil;
  if Assigned(FOnGetRowStyle) then
    Result := FOnGetRowStyle(Params);
end;

procedure TDataGridBase.HandleOnPaginationChanged(
  Event: TJSPaginationChangedEvent);
begin
  OnPaginationChanged(Event);

  if Assigned(FOnPaginationChanged) then
    FOnPaginationChanged(Event);
end;

procedure TDataGridBase.HandleDSDataChanged(Sender: TComponent);
begin
  if Assigned(FAGGrid) then
  begin
    FAGGrid.refreshInfiniteCache;
  end;
end;

procedure TDataGridBase.HandleDSPaginationChanged(Sender: TComponent;
  CurrentPage: Integer;
  PaginationSize: Integer);
var
  pageSize, page, rowCount: Integer;
begin
  if Assigned(FAGGrid) then
  begin
    pageSize := FAGGrid.paginationGetPageSize;
    page := FAGGrid.paginationGetCurrentPage;
    rowCount := FAGGrid.paginationGetRowCount;
    if (PaginationSize > 0) and
       (PaginationSize <> pageSize) then
    begin
      // Page size changed
      CacheBlockSize := PaginationSize;
      FAGGrid.setGridOption('cacheBlockSize', PaginationSize);
      FAGGrid.setGridOption('paginationPageSize', PaginationSize);
    end;

    if (CurrentPage >= 0) and
       (CurrentPage <> page) and
       (rowCount > 0) then
    begin
      // Current page changed
      FAGGrid.paginationGoToPage(CurrentPage);
    end;
  end;
end;

procedure TDataGridBase.HandleOnRowEditingStarted(Params: TJSRowEditingEvent);
begin
  if Assigned(FOnRowEditingStarted) then
    FOnRowEditingStarted(Params);
end;

procedure TDataGridBase.HandleOnRowEditingStopped(Params: TJSRowEditingEvent);
begin
  if Assigned(FOnRowEditingEnded) then
    FOnRowEditingEnded(Params);

  if (FEditType = retCell) and
     Assigned(FServerDataAdapter) and
     Assigned(Params.Data) then
  begin
    TDGServerDataAdapterInternal(FServerDataAdapter).UpdateRow(Self, Params.Data, procedure(RowData: TJSObject)
    begin
      if Assigned(FAGGrid) then
        FAGGrid.refreshInfiniteCache;
    end);
  end;
end;

procedure TDataGridBase.HandleOnRowSelectedEvent(Event: TJSRowSelectedEvent);
begin
  if (_typeof(Event) = 'object') and
     (_typeof(Event.Node) = 'object') and
     (_typeof(TJSObject(Event.Node)['isSelected']) = 'function') then
  begin
    if Event.Node.IsSelected then
    begin
      // Selected
      if Assigned(FOnRowSelected) then
        FOnRowSelected(Event);
    end
    else
    begin
      // Unselected
      if Assigned(FOnRowUnselected) then
        FOnRowUnselected(Event);
    end;
  end
  else
  begin
    console.error('HandleOnRowSelectedEvent() event did not get called with a valid Event parameter!');
    console.log(Event);
  end;
end;

procedure TDataGridBase.HandleOnSelectionChanged(
  Event: TJSSelectionChangedEvent);
begin
  if Assigned(FOnSelectionChanged) then
    FOnSelectionChanged(Event);
end;

procedure TDataGridBase.HandleOnSortChanged(Event: TJSSortChangedEvent);
begin
  if Assigned(FOnSortChanged) then
    FOnSortChanged(Event);
end;

function TDataGridBase.HandleTabToNextCell(Params: TJSTabToNextCellParams): TJSValue;
var
  NewCellPos: TJSCellPosition;
begin
  if Assigned(FOnTabToNextCell) then
    Result := FOnTabToNextCell(Params)
  else
  begin
    Result := False;  // Use default browser behavior
    if (_typeof(Params) <> 'undefined') and
       (_typeof(Params.NextCellPosition) <> 'undefined') and
       (Params.NextCellPosition <> nil) then
    begin
      NewCellPos := TJSCellPosition.Create;
      NewCellPos.Column := Params.NextCellPosition.Column;
      NewCellPos.RowIndex := Params.NextCellPosition.RowIndex;
      NewCellPos.RowPinned := Params.NextCellPosition.RowPinned;
      Result := NewCellPos;
    end;
  end;
end;

procedure TDataGridBase.InitFont(Value: TFont);
begin
  Value.Name := 'Segoe UI';
  Value.Color := clBlack;
  Value.Style := [TFontStyle.fsBold];
  Value.Height := 18;
end;

function TDataGridBase.IsFontStored: Boolean;
begin
  Result := False;
  if Font.Name <> 'Segoe UI' then Result := True;
  if Font.Color <> clBlack then Result := True;
  if Font.Style <> [TFontStyle.fsBold] then Result := True;
  if Font.Height <> 18 then Result := True;

end;

function TDataGridBase.IsLoading: Boolean;
begin
  Result := (csLoading in ComponentState);
end;

procedure TDataGridBase.Clear;
begin
  if Assigned(FAGGrid) then
  begin
    if Assigned(ServerDataAdapter) then
      raise Exception.Create('Error: The Clear method can not be called when the ServerDataAdapter has been assigned!');

    SetRowData(TJSArray._of());
  end;
end;

function TDataGridBase.DeleteSelectedRows: Boolean;
var
  SelectedNodes: TJSRowNodes;
  SelectedLen, DeleteIndex: Integer;
  CurrentNode: TJSRowNode;
  NewRowData: TJSArray;
  I: Integer;
begin
  Result := False;
  if Assigned(FAGGrid) then
  begin
    if Assigned(ServerDataAdapter) then
    begin
      SelectedNodes := FAGGrid.getSelectedNodes;
      SelectedLen := Length(SelectedNodes);
      FAGGrid.deselectAll;
      if SelectedLen > 0 then
      begin
        // Nodes selected
        for I := 0 to SelectedLen - 1 do
        begin
          CurrentNode := SelectedNodes[I];
          ServerDataAdapter.DeleteRow(CurrentNode.Data, procedure(Response: TJSObject)
            begin
              if I = SelectedLen - 1 then
              begin
                // Last row...
                FAGGrid.refreshInfiniteCache;
              end;
            end);
          Result := True;
        end;
      end;
    end
    else
    begin
      // Client row model
      SelectedNodes := FAGGrid.getSelectedNodes;
      SelectedLen := Length(SelectedNodes);
      FAGGrid.deselectAll;
      if SelectedLen > 0 then
      begin
        // Nodes selected
        NewRowData := RowData;

        for I := 0 to SelectedLen - 1 do
        begin
          CurrentNode := SelectedNodes[I];
          if _typeof(CurrentNode.Data) <> 'undefined' then
          begin
            DeleteIndex := NewRowData.indexOf(CurrentNode.Data);
            if DeleteIndex > -1 then
            begin
              NewRowData.splice(DeleteIndex, 1);
            end;
            Result := True;
          end;
        end;
        if Result then
          RowData := NewRowData;
      end;
    end;
  end;
end;


function TDataGridBase.InsertNewRow: Boolean;
var
  LastIndex: Integer;
  TimerId: Integer;
  Row: TJSRowNode;
  NewRowData: TJSArray;
begin
  Result := False;
  
  if Assigned(FAGGrid) then
  begin
    if Assigned(ServerDataAdapter) then
    begin
{$IFDEF OBSOLETE}
      ServerDataAdapter.AGGrid := FAGGrid;
{$ENDIF}

      ServerDataAdapter.InsertRow(new([]), procedure(RowData: TJSObject)
      begin
        TDGServerDataAdapterInternal(ServerDataAdapter).WhenGridRefreshed(procedure
        begin
          EnsureLastRowVisible;
          TimerId := _setTimeout(procedure
          begin
            _clearTimeout(TimerId);
            LastIndex := FAGGrid.getLastDisplayedRowIndex;
            Row := FAGGrid.getDisplayedRowAtIndex(LastIndex);
            if _typeof(Row) <> 'undefined' then
            begin
              Row.SetSelected(True);
              FAGGrid.startEditingCell(new([
                'rowIndex', LastIndex,
                'colKey', ColumnDefs[1].Field
              ]));
            end;
          end, 500);
        end);

        if Assigned(FAGGrid) then
          FAGGrid.refreshInfiniteCache;
      end);
    end
    else
    begin
      // Client row model
      if TJSArray.isArray(RowData) then
      begin
        NewRowData := RowData;
        NewRowData.push(new([]));
        RowData := NewRowData;
      end
      else
      begin
        RowData := TJSArray.new(new([]));
      end;
    end;
  end;
end;



{$ENDREGION}
{$ENDREGION}

{$REGION 'DataGridSearch'}

{ TDataGridSearch }

procedure TDataGridSearch.Load;
begin
  if FIsLoaded then
    Exit
  else
    FIsLoaded := True;

  if Assigned(ElementHandle) and (FPlaceHolder <> '') then
    ElementHandle.Attrs['placeholder'] := FPlaceHolder;
end;

procedure TDataGridSearch.Loaded;
begin
  inherited;
  Load;
end;

function TDataGridSearch.DoHandleChange(Event: TEventListenerEvent): Boolean;
begin
{$IFDEF PAS2JS}
  Result := inherited;
{$ELSE}
  Result := False;
{$ENDIF}
  ApplyQuickFilter;
end;

procedure TDataGridSearch.Notification(AComponent: TComponent;
  Operation: TOperation);
begin
  inherited Notification(AComponent, Operation);
  if Operation = opRemove then
  begin
    if AComponent = FSearchGrid then
      FSearchGrid := nil;
  end;
end;

procedure TDataGridSearch.SetSearchGrid(const Value: TDataGridBase);
begin
  if Value <> FSearchGrid then
  begin
    if FSearchGrid <> nil then
      FSearchGrid.RemoveFreeNotification(Self);

    FSearchGrid := Value;
    if Value <> nil then
      Value.FreeNotification(Self);
  end;
end;

procedure TDataGridSearch.ApplyQuickFilter;
var
  AGGrid: TJSAgGrid;
  SearchString: String;
begin
  if Assigned(FSearchGrid) then
  begin
    AGGrid := FSearchGrid.FAGGrid;
    if Assigned(AGGrid) then
    begin
      SearchString := Text;
      AGGrid.setGridOption('quickFilterText', SearchString);
    end;
  end;
end;

{$ENDREGION}


{$REGION 'TDataGridCustom'}
{ TDataGridCustom }

function TDataGridCustom.DoHttpAbort(Event: TEventListenerEvent): boolean;
begin
  if Assigned(OnHttpRequestError) then
    OnHttpRequestError(Self);

  Result := true;
end;

function TDataGridCustom.DoHttpLoadCsv(Event: TEventListenerEvent): boolean;
var
  sl: TStringList;
  req: TJSXMLHttpRequest;
begin
  req := TJSXMLHttpRequest(Event.target);

  if (req.status >= 200) and (req.status <= 208) then
  begin
    sl := TStringList.Create;

    sl.Text := req.responseText;

    try
      LoadFromStringList(sl);
    finally
      sl.Free;
    end;

    if Assigned(OnHttpRequestSuccess) then
      OnHttpRequestSuccess(Self);
  end;

  Result := true;
end;

function TDataGridCustom.DoHttpLoadJson(Event: TEventListenerEvent): boolean;
var
  J: TJSObject;
  req: TJSXMLHttpRequest;
begin
  req := TJSXMLHttpRequest(Event.target);

  if (req.status >= 200) and (req.status <= 208) then
  begin
    J := TJSJSON.parseObject(req.responseText);

    LoadFromJSON(J, FDataNode);

    if Assigned(OnHttpRequestSuccess) then
      OnHttpRequestSuccess(Self);
  end
  else
  begin
    if Assigned(OnHttpRequestError) then
      OnHttpRequestError(Self);
  end;

  Result := true;
end;

procedure TDataGridCustom.DoHttpRequest(ARequest: TJSXMLHttpRequest);
var
  LRequestRec: TJSXMLHttpRequestRecord;
begin
  if Assigned(OnHttpRequest) then
  begin
    LRequestRec.req := ARequest;
    OnHttpRequest(Self, LRequestRec);
  end;
end;

procedure TDataGridCustom.LoadFromCSV(const AURL: string; Delimiter: char;
  FirstRowColumnLabels: boolean);
begin
  FDelimiter := Delimiter;
  FFirstRowColumnLabels := FirstRowColumnLabels;

  FReq := TJSXMLHttpRequest.new;
  FReq.addEventListener('load',{$IFDEF PAS2JS}@{$ENDIF}DoHttpLoadCsv);
  FReq.addEventListener('abort',{$IFDEF PAS2JS}@{$ENDIF}DoHttpAbort);
  FReq.open('GET', AURL);
  DoHttpRequest(FReq);
  FReq.send;
end;

function TDataGridCustom.LoadFromCSVAsync(const AURL: string; Delimiter: char;
  FirstRowColumnLabels: boolean): TJSPromise;
begin
  Result := TJSPromise.new(
    procedure(ASuccess, AFailed: TJSPromiseResolver)

      function DoLoad(Event: TEventListenerEvent): boolean;
      begin
        if DoHttpLoadCsv(Event) then
          ASuccess(TJSXMLHttpRequest(Event.target))
        else
          AFailed(TJSXMLHttpRequest(Event.target));
        Result := true;
      end;

      function DoError(Event: TEventListenerEvent): boolean;
      begin
        AFailed(TJSXMLHttpRequest(Event.target));
        Result := true;
      end;

    begin
      FDelimiter := Delimiter;
      FFirstRowColumnLabels := FirstRowColumnLabels;
      FReq := TJSXMLHttpRequest.new;
      FReq.addEventListener('load',@DoLoad);
      FReq.addEventListener('abort',@DoError);
      FReq.addEventListener('timeout',@DoError);
      FReq.addEventListener('error',@DoError);

      FReq.open('GET', AURL);
      DoHttpRequest(FReq);
      FReq.send;
    end);
end;

procedure TDataGridCustom.LoadFromCSVString(const CSVString: string;
  Delimiter: char; Quote: char; FirstRowColumnLabels: boolean);
var
  sl: TStringList;
begin
  try
    sl := TStringList.Create;
    sl.Text := CSVString;
    LoadFromStrings(sl, Delimiter, Quote, FirstRowColumnLabels);
  finally
    FreeAndNil(sl);
  end;
end;

procedure TDataGridCustom.LoadFromJSON(AJSON: TJSObject; ADataNode: string);
begin
 if TJSArray.isArray(AJSON) then
  begin
    SetRowData(TJSArray(AJSON));
  end
  else
  begin
    // Invalid data
  end;
end;

function TDataGridCustom.LoadFromJSONAsync(const AURL: string;
  ADataNode: string): TJSPromise;
begin
  Result := TJSPromise.new(
    procedure(ASuccess, AFailed: TJSPromiseResolver)

      function DoLoad(Event: TEventListenerEvent): boolean;
      begin
        if DoHttpLoadJson(Event) then
          ASuccess(TJSXMLHttpRequest(Event.target))
        else
          AFailed(TJSXMLHttpRequest(Event.target));
        Result := true;
      end;

      function DoError(Event: TEventListenerEvent): boolean;
      begin
        AFailed(TJSXMLHttpRequest(Event.target));
        Result := true;
      end;

    begin
      FDataNode := ADataNode;
      FReq := TJSXMLHttpRequest.new;
      FReq.addEventListener('load',@DoLoad);
      FReq.addEventListener('abort',@DoError);
      FReq.addEventListener('timeout',@DoError);
      FReq.addEventListener('error',@DoError);

      FReq.open('GET', AURL);
      DoHttpRequest(FReq);
      FReq.send;
    end);
end;

procedure TDataGridCustom.LoadFromStringList(AStrings: TStrings);
var
  r,c,MaxCol: integer;
  ColCount: Integer;

  RowArr: TJSArray;
  ColArr: TJSArray;
  ColDef: TDGColumnDefsCollectionItemBase;
  Value: String;
  Line, Buffer: String;
  CH: Char;
  I, LineCount, EndQuotePos: Integer;
  InQuote, ContainsQuotes: Boolean;
  LineArr: TJSArray;
  JSBuffer: TJSString;
begin
  RowArr := TJSArray._of;


  ColCount := ColumnDefs.Count;

  for r := 0 to AStrings.Count - 1 do
  begin
    // Parse each Line into the LineArr array
    LineArr := TJSArray._of;
    Line := AStrings.Strings[r];
    LineCount := Length(Line);
    InQuote := False;
    Buffer := '';
    if LineCount > 0 then
    begin
      for I := 1 to LineCount do
      begin
        CH := Line[I];
        if CH = FQuoteChar then
        begin
          InQuote := not InQuote;
          Buffer := Buffer + CH;
        end
        else if (not InQuote) and (CH = FDelimiter) then
        begin
          // Next field
          LineArr.push(Buffer);
          Buffer := '';
        end
        else
        begin
          // Store in buffer
          Buffer := Buffer + CH;
        end;
      end;
        
      LineArr.push(Buffer);
    end;

    for I := 0 to LineArr.Length - 1 do
    begin
      ContainsQuotes := (Pos(String(LineArr[I]), Line) > 0);
      if ContainsQuotes then
      begin
        // Trim spaces
        JSBuffer := TJSString(Trim(String(LineArr[I])));

        // Strip begin and end quotes (if necessary)
        if JSBuffer.StartsWith(FQuoteChar) and
           JSBuffer.EndsWith(FQuoteChar) then
        begin
          EndQuotePos := JSBuffer.indexOf(FQuoteChar, 1);
          if EndQuotePos = JSBuffer.Length - 1 then
          begin
            // There are only two quotes - at the beginning and at the end
            // So we strip them...
            JSBuffer := TJSString(JSBuffer.subString(1, EndQuotePos));
          end;
        end;

        LineArr[I] := JSBuffer;
      end;
    end;

    if FFirstRowColumnLabels and (r = 0) then
    begin
      // Update column definition
      ColumnDefs.Clear;
      MaxCol := LineArr.Length;
      for c := 0 to MaxCol - 1 do
      begin
        ColDef := ColumnDefs.Add;
        ColDef.Field := String(LineArr[c]);
        //TODO: We should add OnLoadColumn here so the ColDef can be modified...
      end;

      ColCount := ColumnDefs.Count;
      continue;
    end;


    if LineArr.Length < ColCount then
      MaxCol := LineArr.Length
    else
      MaxCol := ColCount;

    if MaxCol > 0 then
    begin
      ColArr := TJSArray._of;
      for c := 0 to MaxCol - 1 do
      begin
        if c < ColumnDefs.Count then
        begin
          ColArr.push(ColumnDefs[c].Field);
          Value := String(LineArr[c]);
          try
            case ColumnDefs[c].CellDataType of
              cdtNumber:
                ColArr.push(StrToInt(Value));
              cdtBoolean:
                begin
                  if Value <> '' then
                  begin
                    if (LowerCase(Value) = 'true') or
                       (LowerCase(Value) = 't') or
                       (LowerCase(Value) = 'y') or
                       (Value = '1') then
                      ColArr.push(True)
                    else if (LowerCase(Value) = 'false') or
                       (LowerCase(Value) = 'f') or
                       (LowerCase(Value) = 'n') or
                       (Value = '0') then
                      ColArr.push(False)
                    else
                      ColArr.push(nil);

                  end
                  else
                  begin
                    ColArr.push(nil);
                  end;
                end
              else
                ColArr.push(Value);
            end;
          except on E: Exception do
            asm { debugger; } end;
          end;
        end;
      end;
      RowArr.push(new(TJSValueDynArray(ColArr)));
    end;
  end;

  SetRowData(RowArr);
end;

procedure TDataGridCustom.LoadFromStrings(AStrings: TStrings; Delimiter: char; Quote: char;
  FirstRowColumnLabels: boolean);
begin
  FDelimiter := Delimiter;
  FQuoteChar := Quote;
  FFirstRowColumnLabels := FirstRowColumnLabels;

  LoadFromStringList(AStrings);
end;

procedure TDataGridCustom.SaveToCSV(const AFileName: string; Delimiter: char; Quote: char;
  FirstRowColumnLabels: boolean);
var
  sl: TStringList;
begin
  sl := TStringList.Create;
  try
    SaveToStrings(sl, Delimiter, Quote, FirstRowColumnLabels);
    sl.SaveToFile(AFileName);
  finally
    sl.Free;
  end;
end;

procedure TDataGridCustom.SaveToStrings(AStrings: TStrings; Delimiter: char; Quote: char; FirstRowColumnLabels: boolean);
var
  CSV: String;
  sl: TStringList;
  I: Integer;
begin
  if Assigned(FAGGrid) then
  begin
    CSV := FAGGrid.getDataAsCsv;
    AStrings.Text := CSV;

    if Delimiter <> ',' then
    begin
      // Convert comma to new delimited string
      sl := TStringList.Create;
      try
        for I := 0 to AStrings.Count - 1 do
        begin
          sl.StrictDelimiter := True;
          sl.CommaText := AStrings.Strings[I];
          sl.Delimiter := Delimiter;
          sl.QuoteChar := Quote;
          if Quote <> #0 then
          begin
            asm { sl.FAlwaysQuote = true; } end;
          end;
          AStrings.Strings[I] := sl.DelimitedText;
        end;
      finally
        sl.Free;
      end;
    end;

    if not FirstRowColumnLabels then
    begin
      // Remove the first row as column labels are not needed
      if AStrings.Count > 1 then
        AStrings.Delete(0);
    end;
  end;
end;

function TDataGridCustom.SaveAsCSVToString(Delimiter: char; Quote: char; FirstRowColumnLabels: boolean): String;
var
  sl: TStringList;
begin
  Result := '';
  try
    sl := TStringList.Create;
    SaveToStrings(sl, Delimiter, Quote, FirstRowColumnLabels);
    Result := sl.Text;
  finally
    FreeAndNil(sl);
  end;
end;


procedure TDataGridCustom.LoadFromJSON(const AURL: string; ADataNode: string);
begin
  FDataNode := ADataNode;
  FReq := TJSXMLHttpRequest.new;
  FReq.addEventListener('load',{$IFDEF PAS2JS}@{$ENDIF}DoHttpLoadJson);
  FReq.addEventListener('abort',{$IFDEF PAS2JS}@{$ENDIF}DoHttpAbort);
  FReq.open('GET', AURL);
  DoHttpRequest(FReq);
  FReq.send;
end;
{$ENDREGION}

{$REGION 'Designer Compatibility'}
{$IFDEF DESIGNER}
{ TDGDesignerGridBase }

constructor TDGDesignerGridBase.Create(AOwner: TComponent);
begin
  inherited;
  FCenter := TCenter.Create;
  FCenter.OnChange := DoCenterChanged;
  SetLength(FDesignerGridData, RowCount, ColCount);
  SetLength(FDesignerGridMergeLeft, RowCount, ColCount);
  SetLength(FDesignerGridMergeBottom, RowCount, ColCount);
  FixedCols := 0;
  // Set AG-Grid's default column width and height
  DefaultColWidth := 200;
  DefaultRowHeight := 48;

  FHeightStyle := ssAbsolute;
  FWidthStyle := ssAbsolute;
  FColWidthUpdating := False;

  FSaveCellExtents := False;  //AC: If we don't set FSaveCellExtents to false, then ColWidths will be written to DFM
end;

destructor TDGDesignerGridBase.Destroy;
begin
  if Assigned(FCenter) then
    FreeAndNil(FCenter);
  if Assigned(FDesignerGridData) then
    SetLength(FDesignerGridData, 0, 0);
  if Assigned(FDesignerGridMergeLeft) then
    SetLength(FDesignerGridMergeLeft, 0, 0);
  if Assigned(FDesignerGridMergeBottom) then
    SetLength(FDesignerGridMergeBottom, 0, 0);
  inherited;
end;


procedure TDGDesignerGridBase.DoCenterChanged(Sender: TObject);
begin
  if Assigned(Parent) then
  begin
    if Center.Horizontal and Center.Vertical then
      Align := alCustom
    else if Center.Horizontal or Center.Vertical then
    begin

      Align := alCustom;
    end;

  end;
end;


procedure TDGDesignerGridBase.SetBounds(ALeft, ATop, AWidth, AHeight: Integer);
var
  NewBounds, Rect: TRect;
  dl, dt, dr, db: integer;
begin
  NewBounds.Left := ALeft;
  NewBounds.Top := ATop;
  NewBounds.Width := AWidth;
  Newbounds.Height := AHeight;

  if Assigned(Parent) then
  begin
    if (Width = NewBounds.Width) and (Height = NewBounds.Height) then
    begin
      // No changes in width or height
      if Center.Vertical or Center.Horizontal then
      begin
        if Align = alCustom then
        begin
          Rect := Parent.ClientRect;
          dl := NewBounds.Left;
          dt := NewBounds.Top;
          dr := 0;
          db := 0;

          if Center.Horizontal then
          begin
            dl := Rect.Left;
            dr := (Rect.Right - Rect.Left - NewBounds.Width) div 2;
          end;
          if Center.Vertical then
          begin
            dt := Rect.Top;
            db := (Rect.Bottom - Rect.Top - NewBounds.Height) div 2;
          end;

          NewBounds.Left := dl + dr;
          NewBounds.Top := dt + db;
          NewBounds.Width := Width;
          NewBounds.Height := Height;
        end;
      end;
    end;
  end;

  inherited SetBounds(NewBounds.Left, NewBounds.Top, NewBounds.Width, NewBounds.Height);

  if (csDesigning in ComponentState) and not
     ((csReading in ComponentState) or
     (csLoading in ComponentState)) then
  begin
    Repaint;
  end;
end;

procedure TDGDesignerGridBase.SetCenter(const Value: TCenter);
begin
  FCenter.Assign(Value);
end;

procedure TDGDesignerGridBase.SizeChanged(OldColCount, OldRowCount: Longint);
begin
  inherited;
  if (OldColCount <> ColCount) or
     (OldRowCount <> RowCount) then
  begin
    SetLength(FDesignerGridData, RowCount, ColCount);
    SetLength(FDesignerGridMergeLeft, RowCount, ColCount);
    SetLength(FDesignerGridMergeBottom, RowCount, ColCount);
  end;
end;


procedure TDGDesignerGridBase.DrawCell(ACol, ARow: Longint; ARect: TRect;
  AState: TGridDrawState);
var
  s: string;
  TextRect: TRect;

  I, EmptyRows, AdjustHeight: Integer;
begin
  inherited;

  TextRect := ARect;
  if (ARow < Length(FDesignerGridData)) and (ACol < Length(FDesignerGridData[ARow])) then
  begin
    s := '    ' + FDesignerGridData[ARow][ACol];

    if Length(FDesignerGridData[ARow][ACol]) > 0 then
    begin
      //AC: Cell contains content
      if (ARow + 1 = FixedRows) and
         (FixedRows > 1) then
      begin
        //AC: Last header row
        //AC: Find the number of empty rows above the current cell
        //AC: and adjust the rectange to paint the text
        EmptyRows := 0;
        for I := FixedRows - 2 downto 0 do
        begin
          if Length(FDesignerGridData[I][ACol]) > 0 then
            Break;
          if not FDesignerGridMergeLeft[I][ACol] then
            Inc(EmptyRows);
        end;

        if EmptyRows > 0 then
        begin
          AdjustHeight := ((TextRect.Height + GridLineWidth) * EmptyRows);
          TextRect.Top := TextRect.Top - AdjustHeight;

        end;
      end;
    end;


    Canvas.Font.Assign(Font);
    DrawText(Canvas.Handle, PChar(s), Length(s), TextRect, DT_Left or DT_END_ELLIPSIS or DT_SINGLELINE or DT_VCENTER);

  end;

end;

procedure TDGDesignerGridBase.DrawCellBackground(const ARect: TRect;
  AColor: TColor; AState: TGridDrawState; ACol, ARow: Integer);
var
  NewRect: TRect;
begin
  if (ARow < Length(FDesignerGridData)) and (ACol < Length(FDesignerGridData[ARow])) then
  begin
    NewRect := ARect;
    if FDesignerGridMergeLeft[ARow][ACol] then
      NewRect.Left := NewRect.Left - GridLineWidth;
    if FDesignerGridMergeBottom[ARow][ACol] then
      NewRect.Bottom := NewRect.Bottom + GridLineWidth;
    inherited DrawCellBackground(NewRect, AColor, AState, ACol, ARow);
  end
  else
    inherited DrawCellBackground(ARect, AColor, AState, ACol, ARow);
end;

procedure TDGDesignerGridBase.Paint;
const
  Text1 = 'No columns defined in the';
  Text2 = 'ColumnDefs property';
var
  X: Integer;
  Y: Integer;
begin
  inherited;
  if (csDesigning in ComponentState) and not
     ((csReading in ComponentState) or
     (csLoading in ComponentState)) then
  begin
    if ColumnDefsCount = 0 then
    begin
      X := (Width div 2) - 100;
      Y := Height div 2;
      ExtTextOut(Canvas.Handle, X, Y - 20, 0, nil, PChar(Text1), Length(Text1), nil);
      ExtTextOut(Canvas.Handle, X + 15, Y, 0, nil, PChar(Text2), Length(Text2), nil);
    end;
  end;
end;

function TDGDesignerGridBase.ColumnDefsCount: Integer;
begin
  Result := 0;
end;


{ TArrayHelper<T> }

class procedure TArrayHelper<T>.Sort(var AValues: array of T;
  const AComparer: IComparer<T>);
begin
  TArray.Sort<T>(AValues, AComparer);
end;

{$ENDIF}
{$ENDREGION}


{ TDataGrid }

function TDataGrid.DeleteSelectedRows: Boolean;
begin
  Result := inherited DeleteSelectedRows;
end;

procedure TDataGrid.EnsureLastRowVisible;
begin
  inherited;
end;

function TDataGrid.InsertNewRow: Boolean;
begin
  Result := inherited InsertNewRow;
end;

end.
